!(function (e) {
    var t = e("body"),
        a = e(document),
        o = (e("html"), e(window));
    a.ready(() => {
        a.ajaxStart(() => {
            i.isAjaxLoading = !0;
        }),
            a.ajaxStop(() => {
                i.isAjaxLoading = !1;
            }),
            i.ready();
    }),
        (window.onload = function () {
            i.init();
        });
    var i = {
        haloTimeout: null,
        isAjaxLoading: !1,
        ready: function () {
            this.loaderScript(), this.loaderProductBlock(), navigator.userAgent.match(/OS X.*Safari/) && !navigator.userAgent.match(/Chrome/) ? document.body.classList.add("safari") : document.body.classList.add("chrome");
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && document.body.classList.add("iOS"),
                t.hasClass("template-product") && (this.loaderRecommendationsBlock(), this.scrollToReview()),
                t.hasClass("product-card-layout-07") && this.calculateTranslateYHeight(),
                (window.sharedFunctions = {
                    setLocalStorageProductForWishlist: this.setLocalStorageProductForWishlist,
                    checkNeedToConvertCurrency: this.checkNeedToConvertCurrency,
                    productBlockSilder: this.productBlockSilder,
                    productBlockScroller: this.productBlockScroller,
                    calculateTranslateYHeight: this.calculateTranslateYHeight,
                });
        },
        init: function () {
            this.initMultiTab(),
                this.initMultiTabMobile(),
                this.productBlockInfiniteScroll(),
                this.initGlobalCheckbox(),
                this.initColorSwatch(),
                this.initAddToCart(),
                this.initQuickShop(),
                this.initQuickCart(),
                this.initNotifyInStock(),
                this.initCompareProduct(),
                this.initWishlist(),
                this.initAskAnExpert(),
                this.initHeader(),
                this.headerLanguageCurrency(),
                this.headerMasonry(),
                this.initLiveChat(),
                this.headerSidebarSearch(),
                this.headerStickySearchForm(),
                this.initCountdown(),
                this.collectionCountdown(),
                this.handleScrollDown(),
                this.initVideoPopup(),
                this.swapHoverVideoProductCard(),
                this.initDynamicBrowserTabTitle(),
                this.initWarningPopup(),
                null != document.querySelector("[data-open-quick-view-popup]") && this.initQuickView(),
                window.innerWidth < 1025 && (this.menuSidebarMobile(), this.menuSidebarMobileToggle());
            const a = document.querySelectorAll(".media--loading-effect img"),
                n = document.getElementById("main-collection-product-grid");
            let s;
            (a.length > 0 || n) && this.initLazyloadObserver(a, n),
                t.hasClass("show_effect_close") && this.backgroundOverlayHoverEffect(),
                window.innerWidth > 1024 && this.productMenuSlider(),
                t.hasClass("template-cart") && this.updateGiftWrapper(),
                t.hasClass("template-product") &&
                    (this.initProductView(e(".halo-productView")),
                    this.initProductBundle(),
                    this.articleGallery(),
                    this.toggleSidebarMobile(),
                    this.initCollapseSidebarBlock(),
                    this.initCategoryActive(),
                    this.initProductReviewSection(),
                    this.productCustomInformation(),
                    this.iconZoomClickMobile()),
                (t.hasClass("template-blog") || t.hasClass("template-article")) &&
                    (this.initCollapseSidebarBlock(), this.initCategoryActive(), this.toggleSidebarMobile(), this.initBlogMasonry(), this.productBlockSilderSidebar(), this.productBlockSilderArticle()),
                t.hasClass("template-article") && this.articleGallery(),
                (t.hasClass("template-collection") || t.hasClass("template-search")) &&
                    (this.initCollapseSidebarBlock(), this.initCategoryActive(), this.toggleSidebarMobile(), this.productBlockSilderSidebar(), this.initInfiniteScrolling(), this.initQuickShopProductList()),
                t.hasClass("template-list-collections") && this.toggleSidebarMobile(),
                t.hasClass("template-collection") && e(".collection-express-order").length && (this.toggleVariantsForExpressOrder(), this.initExpressOrderAddToCart()),
                i.checkScrollLayoutForRecenlyViewed(),
                (s = window.innerWidth > 1024),
                o.on("resize", () => {
                    this.headerSidebarSearch(),
                        window.innerWidth > 1024 ? document.body.classList.remove("menu_open") : s && ((s = !1), this.menuSidebarMobile(), this.menuSidebarMobileToggle(), this.initMultiTab(), this.initMultiTabMobile());
                });
        },
        checkNeedToConvertCurrency: function () {
            return (window.show_multiple_currencies && "undefined" != typeof Currency && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        },
        loaderScript: function () {
            var t = function () {
                var t = e("[data-loader-script]");
                t.length > 0 &&
                    t.each((t, a) => {
                        var o = e(a),
                            n = o.data("loader-script"),
                            s = a.getBoundingClientRect().top;
                        o.hasClass("is-load") || (s < window.innerHeight + 100 && (i.buildScript(n), e('[data-loader-script="' + n + '"]').addClass("is-load")));
                    });
            };
            t(), window.addEventListener("scroll", t);
        },
        buildScript: function (e) {
            var t = document.createElement("script");
            (t.src = e), document.body.appendChild(t);
        },
        loaderProductBlock: function () {
            var t = e("[data-product-block]");
            t.length &&
                (t.each((t, a) => {
                    "slider" === e(a).attr("data-layout") && i.productBlockSilder(e(a));
                }),
                window.wishlist.show && i.setLocalStorageProductForWishlist(),
                i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"));
        },
        loaderRecommendationsBlock: function () {
            i.buildRecommendationBlock();
        },
        scrollToReview: function () {
            var t = e(".productView-tab");
            t.length &&
                a.on("click", ".productView-details .halo-productReview", (a) => {
                    a.preventDefault(), e("body,html").animate({ scrollTop: t.offset().top }, 1e3);
                    var o = t.find('[href="#tab-review"]'),
                        i = t.find('[href="#tab-customer-reviews"]'),
                        n = t.find('[href="#tab-review-mobile"]'),
                        s = t.find('[href="#tab-customer-reviews-mobile"]');
                    (o.hasClass("is-open") && n.hasClass("is-open") && i.hasClass("is-open") && s.hasClass("is-open")) || (o[0]?.click(), n[0]?.click(), i[0]?.click(), s[0]?.click());
                });
        },
        headerMasonry: function () {
            e(".menu-dropdown__wrapper [data-masonry]").masonry({ columnWidth: ".grid-sizer", itemSelector: "[data-gridItem]" });
        },
        initLiveChat: function () {
            e(".live-wrapper-icon").on("click", function (t) {
                e(this).parent().toggleClass("live_help--active");
            }),
                t.on("click", function (t) {
                    e(".live_help").hasClass("live_help--active") && 0 === e(event.target).closest(".live_help").length && (t.preventDefault(), e(".live_help").removeClass("live_help--active"));
                });
        },
        initHeader: function () {
            const e = document.querySelectorAll('[class*="section-header"]');
            if (e) {
                let t = e.length + 20;
                e.forEach((e) => {
                    e.classList.contains("section-header-mobile") || (e.setAttribute("data-index", t), (e.style.zIndex = t), t--);
                });
                const a = document.querySelector(".header-basic--transparent");
                if (a && document.body.classList.contains("template-index")) {
                    const e = a.offsetHeight,
                        t = document.querySelector('.header-navigation[class*="--transparent"]');
                    t && ((t.style.top = `${e}px`), t.classList.add("has-top"));
                }
            }
        },
        headerLanguageCurrency: function () {
            if (!document.querySelector(".header-language_currency")) return;
            const e = document.querySelectorAll('[class*="section-header-"]');
            document.addEventListener("click", (t) => {
                const a = t.target,
                    o = a.closest(".header-language_currency"),
                    i = o?.querySelector(".top-language-currency"),
                    n = o?.querySelector(".dropdown-currency"),
                    s = o?.querySelector(".dropdown-language");
                a.matches(".header-language_currency") || a.closest(".header-language_currency")
                    ? (a.matches(".icon-languageCurrency") || a.closest(".icon-languageCurrency")
                          ? i?.classList.toggle("show")
                          : (!a.matches(".top-language-currency") && !a.closest(".top-language-currency")) || document.querySelector(".icon-languageCurrency") || i?.classList.toggle("show"),
                      (a.matches(".halo-top-currency") || a.closest(".halo-top-currency")) && (s?.classList.remove("show"), n?.classList.toggle("show")),
                      (a.matches(".halo-top-language") || a.closest(".halo-top-language")) && (n?.classList.remove("show"), s?.classList.toggle("show")),
                      a.matches(".dropdown-menu .dropdown-item") && (n?.classList.remove("show"), s?.classList.remove("show")))
                    : e.forEach((e) => {
                          e.querySelector(".top-language-currency")?.classList.remove("show"), e.querySelector(".dropdown-currency")?.classList.remove("show"), e.querySelector(".dropdown-language")?.classList.remove("show");
                      });
            });
        },
        headerSidebarSearch: function () {
            e(".header-top .header__search .search_details"), e("#search-form-mobile .halo-sidebar-wrapper .search_details");
            var t = e(".header-top .header__search"),
                a = e("#search-form-mobile .halo-sidebar-wrapper"),
                o = e(".search_details"),
                i = e(".header-top .header__search predictive-search"),
                n = e("#search-form-mobile .halo-sidebar-wrapper predictive-search");
            0 === i.length && (i = e(".header-top .header__search .search_details")),
                0 === n.length && (n = e("#search-form-mobile .halo-sidebar-wrapper .search_details")),
                window.innerWidth < 1025
                    ? (e(".header").hasClass("header-01") && i.appendTo(a),
                      o.attr("open", "true"),
                      e("[data-search-mobile]").on("click", (t) => {
                          t.preventDefault(), e("body").addClass("open_search_mobile");
                      }),
                      e("[data-search-close-sidebar], .background-overlay").on("click", (t) => {
                          t.preventDefault(), e("body").removeClass("open_search_mobile");
                      }))
                    : (e(".header").hasClass("header-01") && n.appendTo(t),
                      o.removeAttr("open"),
                      e(".search-modal__close-button").on("click", (t) => {
                          e(".search_details").removeAttr("open"), e("body").removeClass("open_search_menu");
                      }),
                      e("[data-search-menu]").on("click", (t) => {
                          t.preventDefault(), e("body").addClass("open_search_menu");
                      }));
        },
        headerStickySearchForm: function () {
            var t = "[data-search-sticky-form]",
                a = "[data-search-menu-sticky-form] .icon-search";
            e(window).width() > 1025 &&
                (e(document)
                    .off("click.toggleSearch", t)
                    .on("click.toggleSearch", t, function (t) {
                        t.preventDefault(), t.stopPropagation(), e("body").addClass("sticky-search-open"), e(".search_details").attr("open", "true");
                    }),
                e(document)
                    .off("click.hideSearch")
                    .on("click.hideSearch", function (t) {
                        var a = e(".search-modal__form"),
                            o = e(".quickSearchResultsWrap");
                        !e("body").hasClass("sticky-search-open") ||
                            a.has(t.target).length ||
                            o.has(t.target).length ||
                            (e("body").removeClass("sticky-search-open"), e('[class*="section-header-"]').removeClass("sticky-search-menu-open"), e(".search_details").removeAttr("open"));
                    }),
                e(document)
                    .off("click.toggleSearch", a)
                    .on("click.toggleSearch", a, function (t) {
                        t.preventDefault(),
                            t.stopPropagation(),
                            e(t.target).closest('[class*="section-header-"]').addClass("sticky-search-menu-open"),
                            e(t.target).closest(".section-header-navigation").css("z-index", "101"),
                            e(".search_details").attr("open", "true");
                    }),
                e(document)
                    .off("click.hideSearchSticky")
                    .on("click.hideSearchSticky", function (t) {
                        var o = e(".header-navigation .search-modal__form"),
                            i = e(".header-navigation .quickSearchResultsWrap");
                        if (e('[class*="section-header-"]').hasClass("sticky-search-menu-open") && !o.has(t.target).length && !i.has(t.target).length) {
                            const t = e(a).closest(".section-header-navigation"),
                                o = t.data("index");
                            e('[class*="section-header-"]').removeClass("sticky-search-menu-open"),
                                t.css("z-index", o),
                                e(".header-navigation .search_details").removeAttr("open"),
                                i.hasClass("is-show") && i.removeClass("is-show").addClass("hidden");
                        }
                    }));
        },
        menuSidebarMobile: function () {
            var o = e(".mobileMenu-toggle"),
                n = e(".halo-sidebar-close, .background-overlay");
            o.off("click.toggleCurrencyLanguage").on("click.toggleCurrencyLanguage", (a) => {
                a.preventDefault(),
                    t.addClass("menu_open"),
                    "default" == window.mobile_menu && (e("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").length || e(".header .header__inline-menu").appendTo("#navigation-mobile .site-nav-mobile.nav")),
                    e("#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text").length ||
                        e(".header-top--wrapper .header-top--right .free-shipping-text").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"),
                    e("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").length ||
                        e(".header-top--wrapper .header-top--right .customer-service-text").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"),
                    e("#navigation-mobile .site-nav-mobile.nav-account .header__location").length || e(".header-top--wrapper .header-top--right .header__location").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"),
                    e("#navigation-mobile .top-language-currency").length ||
                        (e(".header").hasClass("header-03")
                            ? e(".header .header-bottom-right .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language")
                            : e(".header").hasClass("header-05")
                            ? e(".header .header-top--left .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language")
                            : e(".header .header-language_currency .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language")),
                    i.productMenuSlider();
            }),
                n.off("click.toggleCloseCurrencyLanguage").on("click.toggleCloseCurrencyLanguage", () => {
                    t.removeClass("menu_open"),
                        e("#navigation-mobile")
                            .off("transitionend.toggleCloseMenu")
                            .on("transitionend.toggleCloseMenu", () => {
                                t.hasClass("menu_open") ||
                                    (e(".header .header__inline-menu").length ||
                                        (e(".header").hasClass("header-03") || e(".header").hasClass("header-04") || e(".header").hasClass("header-07") || e(".header").hasClass("header-08")
                                            ? e("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").appendTo(".header .header-bottom--wrapper .header-bottom-left")
                                            : e("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").appendTo(".header .header-bottom--wrapper")),
                                    e(".header-top--wrapper .header-top--right .free-shipping-text").length ||
                                        e(".header-04").hasClass("style_2") ||
                                        e("#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text").insertBefore(".header-top--wrapper .header-top--right .header__group"),
                                    e(".header-top--wrapper .header-top--right .header__location").length ||
                                        e("#navigation-mobile .site-nav-mobile.nav-account .header__location").insertBefore(".header-top--wrapper .header-top--right .header__group"),
                                    e(".header-top--wrapper .header-top--right .customer-service-text").length ||
                                        (e(".header").hasClass("header-03")
                                            ? e("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").insertBefore(".header-top--wrapper .header-top--right .header__group .header__icon--wishlist")
                                            : e("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").insertBefore(".header-top--wrapper .header-top--right .top-language-currency")),
                                    e(".header-language_currency .top-language-currency").length ||
                                        (e(".header").hasClass("header-03") || e(".header").hasClass("header-04")
                                            ? e("#navigation-mobile .site-nav-mobile .top-language-currency").appendTo(".header .header-bottom--wrapper .header-bottom-right .header-language_currency")
                                            : e(".header").hasClass("header-05")
                                            ? e("#navigation-mobile .site-nav-mobile .top-language-currency").appendTo(".header .header-top--wrapper .header-top--left .header-language_currency")
                                            : e("#navigation-mobile .site-nav-mobile .top-language-currency").insertBefore(".header .header-language_currency .header__search")));
                            });
                }),
                a.on("click", ".halo-sidebar-close", function (e) {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("menu_open");
                });
        },
        menuSidebarMobileToggle: function () {
            t.on("click", ".site-nav-mobile .list-menu .menu_mobile_link", function (t) {
                if (!t.currentTarget.classList.contains("list-menu__item--end")) {
                    t.preventDefault(), t.stopPropagation();
                    var a = e(this),
                        o = a.parent(),
                        i = a.parent().find("ul.list-menu--disclosure-1");
                    o.removeClass("is-hidden").addClass("is-open").removeClass("d-none"),
                        i.off("transitionend.toggleMenuLink1").on("transitionend.toggleMenuLink1", () => {
                            !o.hasClass("is-open") || o.hasClass("is-hidden") || o.hasClass("d-none") || o.siblings().removeClass("is-open").addClass("is-hidden").removeClass("d-none");
                        });
                }
            }),
                t.on("click", ".site-nav-mobile .list-menu .menu_mobile_link_2", function (t) {
                    t.preventDefault(), t.stopPropagation();
                    var a = e(this),
                        o = (a = e(this)).parent().parent(),
                        i = a.parent().find("ul.list-menu--disclosure-2"),
                        n = a.parent().parent().parent().parent().parent().parent();
                    o.removeClass("is-hidden").addClass("is-open").removeClass("d-none"),
                        i.off("transitionend.toggleMenuLink2").on("transitionend.toggleMenuLink2", () => {
                            !o.hasClass("is-open") ||
                                o.hasClass("is-hidden") ||
                                o.hasClass("d-none") ||
                                (o.addClass("d-none"), o.siblings().removeClass("is-open").addClass("is-hidden").removeClass("d-none"), n.animate({ scrollTop: 0 }, 0));
                        }),
                        (e(".menu-dropdown").hasClass("megamenu_style_4") || e(".menu-dropdown").hasClass("megamenu_style_1")) && a.parents(".menu-dropdown").animate({ scrollTop: 0 }, 0),
                        a.parents(".menu-dropdown").addClass("is-overflow");
                }),
                t.on("click", ".nav-title-mobile", function (t) {
                    t.preventDefault(), t.stopPropagation();
                    var a = e(this),
                        o = a.parent().parent().parent().parent(".is-open"),
                        i = a.parent().parent().parent(".is-open"),
                        n = a.parent().parent(".is-open");
                    o.siblings().removeClass("is-hidden"),
                        o.removeClass("is-open").removeClass("d-none"),
                        i.siblings().removeClass("is-hidden"),
                        i.removeClass("is-open").removeClass("d-none"),
                        n.siblings().removeClass("is-hidden"),
                        n.removeClass("is-open").removeClass("d-none"),
                        e(".menu-dropdown").removeClass("is-overflow");
                }),
                "default" != window.mobile_menu &&
                    a.on("click", "[data-mobile-menu-tab]", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        var t = e.currentTarget.closest("li"),
                            a = e.currentTarget.dataset.target;
                        t.classList.contains("is-active") ||
                            document
                                .querySelector("[data-navigation-tab-mobile]")
                                .querySelectorAll("li")
                                .forEach((e) => {
                                    e != t
                                        ? e.classList.remove("is-active")
                                        : (e.classList.add("is-active"),
                                          document.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((e) => {
                                              e.getAttribute("id") == a ? (e.classList.remove("is-hidden"), e.classList.add("is-visible")) : (e.classList.remove("is-visible"), e.classList.add("is-hidden"));
                                          }));
                                });
                    });
        },
        initMultiTab: function () {
            let n;
            if (((n = !!document.body.matches(".shopify-design-mode")), e("[data-menu-tab]").length > 0)) {
                a.on("click", "[data-menu-tab] li", (t) => {
                    var a = e(t.currentTarget).data("load-page");
                    e(t.currentTarget).attr("href");
                    e.cookie("page-url", a, { expires: 1, path: "/" });
                });
                var s,
                    r,
                    l = e("[canonical-shop-url]").attr("canonical-shop-url"),
                    d = e.cookie("page-url");
                if ((-1 !== window.location.pathname.indexOf("/pages/") && window.page_active && window.page_active != d && (setCookie("page-url", window.page_active, 1), (d = window.page_active)), document.URL != l)) {
                    null != d ? ((s = e(`[data-load-page="${d}"]`)), (r = e(`[data-load-logo-page="${d}"]`))) : ((s = e("[data-load-page].is-active")), (r = e("[data-load-logo-page].first")));
                    var c = s.closest("[data-menu-tab]");
                    s.addClass("is-active"), c.find("[data-load-page]").not(s).removeClass("is-active"), r.addClass("is-active"), r.siblings().removeClass("is-active");
                }
                var p = e("[data-menu-tab] li.is-active").data("load-page"),
                    u = !1,
                    h = window.routes.root + `/search?type=product&q=${p}&view=ajax_mega_menu`;
                t.hasClass("template-index")
                    ? o.width() < 1025
                        ? "default" == window.mobile_menu
                            ? window.addEventListener(
                                  "load",
                                  () => {
                                      n
                                          ? 0 == u && ((u = !0), i.initMobileMenuDefault(h))
                                          : document.body.addEventListener(
                                                "touchstart",
                                                () => {
                                                    0 == u && ((u = !0), i.initMobileMenuDefault(h));
                                                },
                                                !1
                                            );
                                  },
                                  !1
                              )
                            : window.addEventListener(
                                  "load",
                                  () => {
                                      n
                                          ? 0 == u && ((u = !0), i.initMultiTabMobile())
                                          : document.body.addEventListener(
                                                "touchstart",
                                                () => {
                                                    0 == u && ((u = !0), i.initMultiTabMobile());
                                                },
                                                !1
                                            );
                                  },
                                  !1
                              )
                        : a.on("mousemove", () => {
                              0 == u && ((u = !0), i.initMenu(h));
                          })
                    : o.width() < 1025
                    ? "default" == window.mobile_menu
                        ? n
                            ? 0 == u && ((u = !0), i.initMobileMenuDefault(h))
                            : document.body.addEventListener(
                                  "touchstart",
                                  () => {
                                      0 == u && ((u = !0), i.initMobileMenuDefault(h));
                                  },
                                  !1
                              )
                        : window.addEventListener(
                              "load",
                              () => {
                                  n
                                      ? 0 == u && ((u = !0), i.initMultiTabMobile())
                                      : document.body.addEventListener(
                                            "touchstart",
                                            () => {
                                                0 == u && ((u = !0), i.initMultiTabMobile());
                                            },
                                            !1
                                        );
                              },
                              !1
                          )
                    : 0 == u && ((u = !0), i.initMenu(h));
            } else {
                (u = !1), (h = window.routes.root + "/search?view=ajax_mega_menu");
                o.width() < 1025 &&
                    ("default" == window.mobile_menu
                        ? n
                            ? 0 == u && ((u = !0), i.initMobileMenuDefault(h))
                            : document.body.addEventListener(
                                  "touchstart",
                                  () => {
                                      0 == u && ((u = !0), i.initMobileMenuDefault(h));
                                  },
                                  !1
                              )
                        : window.addEventListener(
                              "load",
                              () => {
                                  n
                                      ? 0 == u && ((u = !0), i.initMultiTabMobile())
                                      : document.body.addEventListener(
                                            "touchstart",
                                            () => {
                                                0 == u && ((u = !0), i.initMultiTabMobile());
                                            },
                                            !1
                                        );
                              },
                              !1
                          ));
            }
        },
        initMobileMenuDefault: function (t) {
            const a = e("[data-navigation-mobile]"),
                o = e("#HeaderNavigation [data-navigation]"),
                i = null != o.attr("style") ? o.attr("style") : o.closest("#HeaderNavigation").attr("style");
            a.append(`<nav class="header__inline-menu" data-navigation role="navigation" style="${null != i ? i : ""}">${null != o.html() ? o.html() : ""}</nav>`);
            const n = e(".top-language-currency"),
                s = e("#navigation-mobile .nav-currency-language");
            "" == s.text().trim() && n.length > 0 && s.append(`<div class="top-language-currency">${n.html()}</div>`);
        },
        initMultiTabMobile: function () {
            if (o.width() < 1025 && "custom" == window.mobile_menu) {
                var t = !1,
                    a = e('[data-section-type="menu"]'),
                    i = e("[data-navigation-mobile]"),
                    n = e("[data-navigation-tab-mobile]");
                document.body.addEventListener(
                    "click",
                    () => {
                        if (0 == t) {
                            t = !0;
                            const e = document.createElement("div"),
                                o = document.createElement("ul");
                            Object.assign(o, { className: "menu-tab list-unstyled" }),
                                o.setAttribute("role", "menu"),
                                a.each((t, a) => {
                                    var o = a.querySelector("template").content.firstElementChild.cloneNode(!0);
                                    0 == t ? o.classList.add("is-visible") : o.classList.add("is-hidden"), e.appendChild(o);
                                }),
                                e.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((e, t) => {
                                    var a = e.dataset.heading,
                                        i = e.getAttribute("id"),
                                        n = document.createElement("li");
                                    Object.assign(n, { className: "item" }),
                                        n.setAttribute("role", "menuitem"),
                                        0 == t && n.classList.add("is-active"),
                                        (n.innerHTML = `<a class="link" href="#" data-mobile-menu-tab data-target="${i}">${a}</a>`),
                                        o.appendChild(n);
                                }),
                                n.html(o),
                                i.html(e.innerHTML);
                        }
                    },
                    !1
                );
            }
        },
        initMenu: function (t) {
            e(".header").hasClass("header-04") ||
                fetch(t)
                    .then((e) => e.text())
                    .then((e) => {
                        const t = document.createElement("div");
                        t.innerHTML = e;
                        const a = t.querySelector("#HeaderNavigation");
                        a && a.innerHTML.trim().length && (document.querySelector("#HeaderNavigation").innerHTML = a.innerHTML);
                    })
                    .catch((e) => {
                        console.error(e);
                    });
        },
        productBlockSilder: function (e) {
            var t = e.find(".products-carousel"),
                a = t.data("item-to-show"),
                o = t.data("item-dots"),
                i = t.data("item-dots-mb"),
                n = t.data("item-arrows"),
                s = t.data("item-arrows-mb"),
                r = document.body.classList.contains("product-card-layout-06");
            if (t.length > 0) {
                if (t.hasClass("slick-initialized")) return;
                t.not(".slick-initialized") &&
                    (r &&
                        t.on("init", () => {
                            const e = t.find(".product .card-action").eq(0).height();
                            t.find(".slick-list").css("padding-bottom", e + "px"), t.attr("data-slider-padding-bottom", e);
                        }),
                    t.slick({
                        mobileFirst: !0,
                        adaptiveHeight: !0,
                        vertical: !1,
                        infinite: !0,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: s,
                        dots: i,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            {
                                breakpoint: 1599,
                                settings: {
                                    arrows: n,
                                    dots: o,
                                    get slidesToShow() {
                                        return (this.slidesToShow = null != a && "" !== a ? a : 1);
                                    },
                                    get slidesToScroll() {
                                        return (this.slidesToScroll = null != a && "" !== a ? a : 1);
                                    },
                                },
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    arrows: n,
                                    dots: o,
                                    get slidesToShow() {
                                        return null != a && "" !== a
                                            ? 5 == a || 6 == a
                                                ? (this.slidesToShow = a - 1)
                                                : t.parents(".collection-column-2").length
                                                ? (this.slidesToShow = 2)
                                                : (this.slidesToShow = a)
                                            : (this.slidesToShow = 1);
                                    },
                                    get slidesToScroll() {
                                        return null != a && "" !== a
                                            ? 5 == a || 6 == a
                                                ? (this.slidesToScroll = a - 1)
                                                : t.parents(".collection-column-2").length
                                                ? (this.slidesToScroll = 2)
                                                : (this.slidesToScroll = a)
                                            : (this.slidesToScroll = 1);
                                    },
                                },
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    arrows: s,
                                    dots: i,
                                    get slidesToShow() {
                                        return t.hasClass("has__banner_tab") || t.parents(".product-block-has__banner").length
                                            ? t.parents(".product-block-has__banner").length && t.parents(".product-block-has__banner").data("width-banner") > 40
                                                ? (this.slidesToShow = 2)
                                                : (this.slidesToShow = 3)
                                            : t.parents(".collection-column-2").length
                                            ? (this.slidesToShow = 2)
                                            : (this.slidesToShow = 4);
                                    },
                                    get slidesToScroll() {
                                        return t.hasClass("has__banner_tab") || t.parents(".product-block-has__banner").length
                                            ? t.parents(".product-block-has__banner").length && t.parents(".product-block-has__banner").data("width-banner") > 40
                                                ? (this.slidesToScroll = 2)
                                                : (this.slidesToScroll = 3)
                                            : t.parents(".collection-column-2").length
                                            ? (this.slidesToScroll = 2)
                                            : (this.slidesToScroll = 4);
                                    },
                                },
                            },
                            {
                                breakpoint: 767,
                                arrows: s,
                                dots: i,
                                settings: {
                                    get slidesToShow() {
                                        return t.hasClass("has__banner_tab") || t.parents(".product-block-has__banner").length ? (this.slidesToShow = 2) : (this.slidesToShow = 3);
                                    },
                                    get slidesToScroll() {
                                        return t.hasClass("has__banner_tab") || t.parents(".product-block-has__banner").length ? (this.slidesToScroll = 2) : (this.slidesToScroll = 3);
                                    },
                                },
                            },
                            { breakpoint: 320, arrows: s, dots: i, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                        ],
                    }),
                    e.hasClass("ajax-loaded"));
            }
        },
        productBlockInfiniteScroll: function () {
            e("[data-product-block], [data-product-tab-block]").each((t, a) => {
                var o = e(a),
                    n = o.find("[data-product-infinite]");
                n.length > 0 &&
                    n.find(".button").on("click", (t) => {
                        var a = e(t.target);
                        if (!a.hasClass("view-all")) {
                            t.preventDefault(), t.stopPropagation(), a.addClass("is-loading");
                            var n = a.attr("data-collection"),
                                s = a.attr("data-limit"),
                                r = a.attr("data-swipe"),
                                l = a.attr("data-total"),
                                d = a.attr("data-image-ratio"),
                                c = a.attr("sectionId"),
                                p = parseInt(a.attr("data-page"));
                            i.doProductBlockInfiniteScroll(n, l, s, r, d, c, p, a, o);
                        }
                    });
            });
        },
        doProductBlockInfiniteScroll: function (t, a, o, n, s, r, l, d, c) {
            e.ajax({
                type: "get",
                url: window.routes.root + "/collections/" + t,
                cache: !1,
                data: { view: "ajax_product_block_load_more", constraint: "limit=" + o + "+page=" + l + "+sectionId=" + r + "+imageRatio=" + s + "+swipe=" + n },
                beforeSend: function () {},
                success: function (i) {
                    const n = d.closest(".tab-content").length ? d.closest(".tab-content").find(".products-grid") : d.closest(".halo-block-content").find(".products-grid");
                    n.append(i);
                    var s = n.find(".product").length;
                    if (e(i).length == o && s < 50) {
                        var r = window.button_load_more.default;
                        d.removeClass("is-loading"), d.attr("data-page", l + 1), d.find("span").text(r);
                    } else if (a > 50) {
                        r = window.button_load_more.view_all;
                        d.find("span").text(r), d.removeClass("is-loading"), d.attr("href", window.routes.root + "/collections/" + t).addClass("view-all");
                    } else {
                        r = window.button_load_more.no_more;
                        d.find("span").text(r), d.removeClass("is-loading"), d.attr("disabled", "disabled");
                    }
                },
                complete: function () {
                    if (
                        (i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                        window.review.show && e(".shopify-product-reviews-badge").length > 0)
                    )
                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                },
            });
        },
        productMenuSlider: function () {
            var t = e(".megamenu_style_5");
            t.length > 0 &&
                t.each((t, a) => {
                    let o = e(a).find(".products-carousel"),
                        i = o.data("row");
                    o.not(".slick-initialized") &&
                        o.slick({
                            mobileFirst: !0,
                            adaptiveHeight: !0,
                            vertical: !1,
                            infinite: !1,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            arrows: !1,
                            dots: !0,
                            rtl: window.rtl_slick,
                            responsive: [
                                { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                                { breakpoint: 1500, settings: { slidesToShow: i, slidesToScroll: 1, dots: !1 } },
                            ],
                        });
                });
        },
        buildRecommendationBlock: function () {
            if (null == document.querySelector("[data-recommendations-block]")) return;
            var t = document.querySelector("[data-recommendations-block]"),
                a = t.dataset.layout;
            swipe = t.dataset.swipe;
            new IntersectionObserver(
                ((o, n) => {
                    const s = t.querySelector(".wrapper-container");
                    o[0].isIntersecting &&
                        ("" == t.innerHTML.trim() || s.classList.contains("product-recommendations-loading") || s.classList.contains("has-product")) &&
                        (s.classList.add("has-product"),
                        fetch(t.dataset.url)
                            .then((e) => e.text())
                            .then((o) => {
                                const n = document.createElement("div");
                                n.innerHTML = o;
                                const s = n.querySelector("[data-recommendations-block]");
                                if (s && s.innerHTML.trim().length) {
                                    if (((t.innerHTML = s.innerHTML), !e(t).find(".product-item").eq(0).data("json-product"))) return e(t).remove();
                                    if ("slider" == a) i.productBlockSilder(e(t));
                                    else if ("scroll" == a) {
                                        const a = e(t).find("[data-enable-hover]").attr("data-enable-hover"),
                                            o = t.closest(".products-flex");
                                        "true" === a && o.clientWidth < o.scrollWidth && i.productBlockScroller(e(t));
                                    }
                                    e(t)
                                        .find(".product-item")
                                        .each(async (t, a) => {
                                            var o = e(a),
                                                n = o.data("product-id"),
                                                s = o.data("json-product").handle;
                                            await e.ajax({
                                                type: "get",
                                                url: window.routes.root + "/products/" + s + "?view=ajax_variant_quantity",
                                                beforeSend: function () {},
                                                success: function (e) {
                                                    const t = new DOMParser().parseFromString(e, "text/html");
                                                    if (t.querySelector(`[data-quantity-product-id="${n}"]`)) {
                                                        const e = JSON.parse(t.querySelector(`[data-quantity-product-id="${n}"]`).innerHTML);
                                                        window[`quick_view_inven_array_${n}`] = e;
                                                    }
                                                },
                                                error: function (t, a) {
                                                    i.showWarning(e.parseJSON(t.responseText).description);
                                                },
                                                complete: function () {},
                                            });
                                        });
                                    const o = t.querySelectorAll(".media--loading-effect img");
                                    if ((this.observeImageLazyloaded(o), window.compare.show)) {
                                        var r = e("a[data-compare-link]");
                                        i.setLocalStorageProductForCompare(r);
                                    }
                                    if ((window.wishlist.show && i.setLocalStorageProductForWishlist(), window.review.show && e(".shopify-product-reviews-badge").length > 0))
                                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                                    this.calculateTranslateYHeight();
                                }
                            })
                            .catch((e) => {
                                console.error(e);
                            }));
                }).bind(t),
                { rootMargin: "1000px" }
            ).observe(t);
        },
        initVideoPopup: function () {
            e(".video-open-popup").length &&
                (e(".video-open-popup .video-button")
                    .off("click")
                    .on("click", function () {
                        let a = e(this).attr("data-type"),
                            o = e(this).attr("data-src");
                        const i = `<div class="fluid-width-video-wrapper" style="padding-top: ${e(this).attr("aspect_ratio")}">\n                                    ${
                            "youtube" == a
                                ? `<iframe\n                                            id="player"\n                                            type="text/html"\n                                            width="100%"\n                                            frameborder="0"\n                                            webkitAllowFullScreen\n                                            mozallowfullscreen\n                                            allowFullScreen\n                                            src="https://www.youtube.com/embed/${o}?autoplay=1&mute=1">\n                                        </iframe>`
                                : `<iframe \n                                            src="https://player.vimeo.com/video/${o}?autoplay=1&mute=1" \n                                            class="js-vimeo" \n                                            allow="autoplay; \n                                            encrypted-media" \n                                            webkitallowfullscreen \n                                            mozallowfullscreen \n                                            allowfullscreen">\n                                        </iframe>`
                        }\n                                </div>`;
                        e("[data-popup-video]").find(".halo-popup-content").html(i), t.addClass("video-show");
                    }),
                e("[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay").on("click", function (a) {
                    let o = e("[data-popup-video] .halo-popup-content");
                    o.is(a.target) || o.has(a.target).length || (t.removeClass("video-show"), e("[data-popup-video] iframe").remove());
                }));
        },
        swapHoverVideoProductCard: function () {
            window.innerWidth > 1200 &&
                (e(".product-item .card").mouseenter(function () {
                    var t = e(this).find("video"),
                        a = e(this).find("video").get(0);
                    t.length > 0 && a.play();
                }),
                e(".product-item .card").mouseleave(function () {
                    var t = e(this).find("video"),
                        a = e(this).find("video").get(0);
                    t.length > 0 && a.pause();
                }));
        },
        initGlobalCheckbox: function () {
            a.on("change", ".global-checkbox--input", (t) => {
                var a = t.target.getAttribute("data-target");
                t.target.checked ? e(a).attr("disabled", !1) : e(a).attr("disabled", !0);
            }),
                a.on("click", "[data-term-condition]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.addClass("term-condition-show");
                }),
                a.on("click", "[data-close-term-condition-popup]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("term-condition-show");
                }),
                a.on("click", (a) => {
                    setTimeout(() => {
                        t.hasClass("cart-sidebar-show") && 0 === e(a.target).closest("[data-term-condition-popup]").length && t.removeClass("term-condition-show"),
                            t.hasClass("term-condition-show") && 0 === e(a.target).closest("[data-term-condition-popup]").length && t.removeClass("term-condition-show");
                    }, 10);
                });
        },
        initColorSwatch: function () {
            a.ready(function () {
                e(".card .swatch-label.is-active").trigger("click");
            }),
                a.on("click", ".card .swatch-label", (a) => {
                    var o = e(a.currentTarget),
                        n = o.attr("title").replace(/^\s+|\s+$/g, ""),
                        s = o.closest(".product-item"),
                        r = s.data("json-product"),
                        l = s.find(".card-title"),
                        d = s.find("[data-btn-addtocart]"),
                        c = o.data("variant-id"),
                        p = s.find("a").attr("href"),
                        u = o.data("with-one-option"),
                        h = o.data("variant-img"),
                        m = [];
                    o.parents(".swatch").find(".swatch-label").removeClass("is-active"),
                        o.addClass("is-active"),
                        l.hasClass("card-title-change")
                            ? t.hasClass("style_2_text_color_varriant")
                                ? l.find("[data-change-title]").text(n)
                                : l.find("[data-change-title]").text(" - " + n)
                            : t.hasClass("style_2_text_color_varriant")
                            ? l.addClass("card-title-change").append("<span data-change-title>" + n + "</span>")
                            : l.addClass("card-title-change").append("<span data-change-title> - " + n + "</span>");
                    const w = r.variants.find((e) => e.id === c);
                    if (w.compare_at_price > w.price) {
                        s.find(".price__sale .price-item--regular").html(Shopify.formatMoney(w.compare_at_price, window.money_format)), s.find(".price__sale .price-item--sale").html(Shopify.formatMoney(w.price, window.money_format));
                        const e = `-${Math.round((100 * (w.compare_at_price - w.price)) / w.compare_at_price)}%`;
                        s.find(".price__label_sale .label_sale").html(e);
                    } else s.find(".price__regular .price-item").html(Shopify.formatMoney(w.price, window.money_format));
                    if ((s.find("a:not(.single-action):not(.number-showmore)").attr("href", p.split("?variant=")[0] + "?variant=" + c), null != u)) {
                        var f = o.data("quantity");
                        s.find('[name="id"]').val(u),
                            f > 0
                                ? window.notify_me.show
                                    ? d.removeClass("is-notify-me").addClass("is-visible")
                                    : d.removeClass("is-soldout").addClass("is-visible")
                                : window.notify_me.show
                                ? d.removeClass("is-visible").addClass("is-notify-me")
                                : d.removeClass("is-visible").addClass("is-soldout"),
                            d.hasClass("is-soldout") || d.hasClass("is-notify-me")
                                ? d.hasClass("is-notify-me")
                                    ? d.text(window.notify_me.button)
                                    : d.text(window.variantStrings.soldOut).prop("disabled", !0)
                                : d.text(window.variantStrings.addToCart).prop("disabled", !1);
                    } else
                        null != r && window.quick_shop.show && i.checkStatusSwatchQuickShop(s, r),
                            s
                                .find('.swatch-element[data-value="' + n + '"]')
                                .find(".single-label")
                                .trigger("click");
                    if (null != r.media) m = r.media.filter((e, t) => t.alt === n);
                    if (m.length > 0) {
                        if (m.length > 1) var v = 2;
                        else v = m.length;
                        for (var g = 0; g < v; g++) s.find(".card-media img:eq(" + g + ")").attr("srcset", m[g].src);
                    } else h && s.find(".card-media img:nth-child(1)").attr("srcset", h);
                    i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format");
                }),
                a.on("click", ".item-swatch-more .number-showmore", (t) => {
                    e(t.target).closest(".swatch").hasClass("show--more")
                        ? (e(t.target).closest(".swatch").removeClass("show--more"), e(t.target).find("span:eq(0)").text("+"))
                        : (e(t.target).closest(".swatch").addClass("show--more"), e(t.target).find("span:eq(0)").text("-"));
                });
        },
        checkPreOrderOfVariant: function (t, a, o) {
            const n = t.id,
                s = (e, t, a) => {
                    const o = e.parents(".product-item").find("[data-quickshop-popup]").length > 0;
                    null == t.inventory_management
                        ? e
                              .text(o ? window.variantStrings.add : window.variantStrings.addToCart)
                              .prop("disabled", !1)
                              .addClass("button--pre-untrack")
                        : t.available && a <= 0
                        ? e.text(window.variantStrings.preOrder).prop("disabled", !1).addClass("button--pre-untrack")
                        : (e.removeClass("button--pre-untrack"),
                          a > 0
                              ? window.notify_me.show
                                  ? e.removeClass("is-notify-me").addClass("is-visible")
                                  : e.removeClass("is-soldout").addClass("is-visible")
                              : window.notify_me.show
                              ? e.removeClass("is-visible").addClass("is-notify-me").prop("disabled", !1)
                              : e.removeClass("is-visible").addClass("is-soldout").prop("disabled", !0),
                          e.hasClass("is-soldout") || e.hasClass("is-notify-me")
                              ? e.hasClass("is-notify-me")
                                  ? e.text(window.notify_me.button).prop("disabled", !1).removeClass("btn-unavailable")
                                  : e.text(window.variantStrings.soldOut).prop("disabled", !0)
                              : e.text(o ? window.variantStrings.add : window.variantStrings.addToCart).prop("disabled", !1));
                },
                r = `quick_view_inven_array_${o.id}`;
            var l = window[r];
            if (null != l) {
                var d = l[n],
                    c = parseInt(d);
                s(a, t, c);
            } else
                e.ajax({
                    type: "get",
                    url: window.routes.root + "/products/" + o.handle + "?view=ajax_quick_shop_data",
                    beforeSend: function () {},
                    success: function (e) {
                        window[r] = JSON.parse(e.split("=")[1]);
                        var o = window[r][n],
                            i = parseInt(o);
                        s(a, t, i);
                    },
                    error: function (t, a) {
                        i.showWarning(e.parseJSON(t.responseText).description);
                    },
                    complete: function () {},
                });
        },
        initQuickShop: function () {
            window.quick_shop.show &&
                (a.on("click", "[data-quickshop-popup]", (n) => {
                    n.preventDefault(), n.stopPropagation();
                    var s = e(n.target),
                        r = s.parents(".product-item"),
                        l = r.data("json-product"),
                        d = r.find(".variants-popup");
                    if (r.hasClass("quickshop-popup-show")) i.initAddToCartQuickShop(s, d);
                    else {
                        if ((e(".product-item").removeClass("quickshop-popup-show"), t.hasClass("quick_shop_option_2"))) {
                            var c = r.find(".card-media").outerHeight(!0),
                                p = d.find(".variants");
                            t.hasClass("product-card-layout-02")
                                ? o.width() > 1024
                                    ? (p.css("max-height", c - 114 + "px"), p.css("min-height", c - 114 + "px"))
                                    : (p.css("max-height", c - 70 + "px"), p.css("min-height", c - 70 + "px"))
                                : t.hasClass("product-card-layout-04")
                                ? o.width() > 1024
                                    ? (p.css("max-height", c - 116 + "px"), p.css("min-height", c - 116 + "px"))
                                    : (p.css("max-height", c - 70 + "px"), p.css("min-height", c - 70 + "px"))
                                : o.width() > 1024
                                ? (p.css("max-height", c - 74 + "px"), p.css("min-height", c - 74 + "px"))
                                : (p.css("max-height", c - 20 + "px"), p.css("min-height", c - 20 + "px")),
                                p[0].scrollHeight > p[0].clientHeight && p.addClass("scrollable"),
                                e(".productListing").hasClass("productList") || i.appendProductQuickShopOption2(r);
                        } else if (t.hasClass("quick_shop_option_3")) {
                            const o = s.data("product-handle");
                            e(".productListing").hasClass("productList") || i.updateContentQuickshopOption3(o),
                                a.on("click", "[data-close-quick-shop-popup]", (e) => {
                                    e.preventDefault(), e.stopPropagation(), t.removeClass("quickshop-popup-show");
                                }),
                                a.off("click.quickShopOverlay").on("click.quickShopOverlay", (a) => {
                                    t.hasClass("quickshop-popup-show") && e(a.target).is(".background-overlay") && t.removeClass("quickshop-popup-show");
                                });
                        }
                        if (
                            (t.hasClass("quick_shop_option_3")
                                ? e(".productListing").hasClass("productList") && (o.width() < 767 ? i.appendToListViewModal(r) : r.addClass("quickshop-popup-show"))
                                : o.width() < 767 && e(".productListing").hasClass("productList")
                                ? i.appendToListViewModal(r)
                                : r.addClass("quickshop-popup-show"),
                            r.find(".swatch-label.is-active").trigger("click"),
                            i.checkStatusSwatchQuickShop(r, l),
                            e(".card-swatch").hasClass("quick_shop_type_2") || (e("productListing").hasClass("productList") && !e(".card-swatch").hasClass("quick_shop_type_3")))
                        ) {
                            if (o.width() < 767)
                                if (e(".productListing").hasClass("productList"))
                                    d.find(".selector-wrapper").each((t, a) => {
                                        e(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click");
                                    });
                                else
                                    e("#halo-card-mobile-popup .variants-popup")
                                        .find(".selector-wrapper")
                                        .each((t, a) => {
                                            e(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click");
                                        });
                            else
                                d.find(".selector-wrapper").each((t, a) => {
                                    e(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click");
                                });
                            e(".productListing").hasClass("productList") || t.addClass("quick_shop_popup_mobile");
                        } else
                            d.find(".selector-wrapper:not(.option-color)").each((t, a) => {
                                e(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click");
                            });
                    }
                    i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format");
                }),
                a.on("click", "[data-cancel-quickshop-popup]", (o) => {
                    o.preventDefault(), o.stopPropagation();
                    var i = e(o.currentTarget).parents(".product-item"),
                        n = a.find("#halo-card-mobile-popup");
                    i.removeClass("quickshop-popup-show"),
                        a.find(".quickshop-popup-show").removeClass("quickshop-popup-show"),
                        t.removeClass("quickshop-list-view-show"),
                        e(".card-swatch").hasClass("quick_shop_type_2") && (t.removeClass("quick_shop_popup_mobile"), n.removeClass("show"));
                }),
                a.on("click", (a) => {
                    0 === e(a.target).closest("[data-quickshop-popup]").length &&
                        0 === e(a.target).closest(".variants-popup").length &&
                        0 === e(a.target).closest(".card-swatch").length &&
                        0 === e(a.target).closest("[data-warning-popup]").length &&
                        (e(".product-item").removeClass("quickshop-popup-show"), e(".card-swatch").hasClass("quick_shop_type_2") && t.removeClass("quick_shop_popup_mobile"));
                }),
                i.changeSwatchQuickShop());
        },
        appendToListViewModal: function (o) {
            const i = a.find("#list-view-popup"),
                n = o.clone();
            i.find(".halo-popup-content").empty(), i.find(".halo-popup-content").append(n);
            const s = i.find("[data-quickshop] .card-information .variants-popup form").eq("0"),
                r = s.attr("id") + "-mobile",
                l = s.find(".single-option"),
                d = s.find(".single-label"),
                c = (i.find(".card-product"), i.find(".variants-popup")),
                p = i.find("[data-btn-addtocart]");
            c.removeClass("card-list__hidden");
            let u = { selected1: !1, selected2: !1, selected3: !1 };
            s.attr("id", r),
                p.attr("data-form-id", p.attr("data-form-id") + "-mobile"),
                l.each((t, a) => {
                    e(a).attr("id", e(a).attr("id") + "-mobile"), e(a).attr("name", e(a).attr("name") + "-mobile");
                }),
                d.each((t, a) => {
                    e(a).attr("for", e(a).attr("for") + "-mobile");
                    const o = e(a).closest(".selector-wrapper");
                    e(a).closest(".swatch-element").hasClass("available") &&
                        (o.hasClass("selector-wrapper-1") && !u.selected1
                            ? ((u.selected1 = !0), e(a).trigger("click"))
                            : o.hasClass("selector-wrapper-2") && !u.selected2
                            ? ((u.selected2 = !0), e(a).trigger("click"))
                            : o.hasClass("selector-wrapper-3") && !u.selected3 && ((u.selected3 = !0), e(a).trigger("click")));
                }),
                t.addClass("quickshop-list-view-show"),
                e(".background-overlay")
                    .off("click.closeListViewModal")
                    .on("click.closeListViewModal", () => {
                        t.removeClass("quickshop-list-view-show");
                    });
        },
        changeSwatchQuickShop: function () {
            a.on("change", "[data-quickshop] .single-option", (a) => {
                var n,
                    s,
                    r = e(a.target),
                    l = r.parents(".product-item"),
                    d = l.data("json-product"),
                    c = l.find("[data-btn-addtocart]"),
                    p = l.find(".option-color").data("option-position"),
                    u = r.closest("[data-option-index]").data("option-index"),
                    h = l.find(".swatch-element"),
                    m = r.val(),
                    w = l.find("[name=id]"),
                    f = l.find(".selector-wrapper-1").find("input:checked").val(),
                    v = l.find(".selector-wrapper-2").find("input:checked").val();
                l.find(".selector-wrapper-3").find("input:checked").val();
                switch (
                    (t.hasClass("quick_shop_option_2") && e(".productListing").hasClass("productList")
                        ? (f = l.find(".selector-wrapper-1").eq("1").find("input:checked").val())
                        : e(".productListing").hasClass("productList") && o.width() < 767
                        ? ((f = l.find(".selector-wrapper-1").eq("1").find("input:checked").val()), (v = l.find('[data-option-index="1"]').eq("1").find("input:checked").val()))
                        : (f = l.find(".selector-wrapper-1").eq("0").find("input:checked").val()),
                    null != d && (n = d.variants),
                    h.removeClass("soldout"),
                    h.find('input[type="radio"]').prop("disabled", !1),
                    u)
                ) {
                    case 0:
                        if (null != (g = n.find((e) => (1 == p ? e.option2 == m && e.option1 == v : 2 == p ? e.option3 == m && e.option1 == v : e.option1 == m && e.option2 == v)))) s = g;
                        else s = n.find((e) => (1 == p ? e.option2 == m : 2 == p ? e.option3 == m : e.option1 == m));
                        break;
                    case 1:
                        if (null != (g = n.find((e) => (1 == p ? e.option2 == f && e.option1 == m && e.option3 == v : 2 == p ? e.option3 == f && e.option1 == m && e.option2 == v : e.option1 == f && e.option2 == m && e.option3 == v))))
                            s = g;
                        else s = n.find((e) => (1 == p ? e.option2 == f && e.option1 == m : 2 == p ? e.option3 == f && e.option1 == m : e.option1 == f && e.option2 == m));
                        break;
                    case 2:
                        var g;
                        null != (g = n.find((e) => (1 == p ? e.option2 == f && e.option1 == v && e.option3 == m : 2 == p ? e.option3 == f && e.option1 == v && e.option2 == m : e.option1 == f && e.option2 == v && e.option3 == m))) &&
                            (s = g);
                }
                if (null != s) {
                    w.val(s.id);
                    var C = r.val();
                    r.parents(".selector-wrapper").find(".form-label span").text(C),
                        s.available
                            ? (l.find("[data-btn-addtocart]").removeClass("btn-unavailable"), l.find("[data-quickshop] quickshop-update-quantity").removeClass("disabled"), l.find("[data-btn-addtocart]").attr("data-available", "true"))
                            : (l.find("[data-btn-addtocart]").addClass("btn-unavailable"), l.find("[data-quickshop] quickshop-update-quantity").addClass("disabled"), l.find("[data-btn-addtocart]").attr("data-available", "false")),
                        i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                        !t.hasClass("quick_shop_option_2") && !t.hasClass("quick_shop_option_3") && o.width(),
                        i.checkStatusSwatchQuickShop(l, d),
                        i.checkPreOrderOfVariant(s, c, d);
                }
            });
        },
        checkStatusSwatchQuickShop: function (a, i) {
            var n,
                s = a.find(".card-variant"),
                r = a.find("[data-option-index]"),
                l = a.find(".option-color").data("option-position"),
                d = a.find('[data-option-index="0"]').find("input:checked").val(),
                c = a.find('[data-option-index="1"]').find("input:checked").val(),
                p = a.find('[data-option-index="2"]').find("input:checked").val(),
                u = a.data("product-id");
            if (t.hasClass("quick_shop_option_2")) {
                var h = a.find(".card-media").outerHeight(!0);
                null != p
                    ? t.hasClass("product-card-layout-01")
                        ? h < 310
                            ? e("[data-quickshop]").addClass("active_option_3")
                            : e("[data-quickshop]").removeClass("active_option_3")
                        : h < 370
                        ? e("[data-quickshop]").addClass("active_option_3")
                        : e("[data-quickshop]").removeClass("active_option_3")
                    : o.width() > 1024
                    ? t.hasClass("product-card-layout-05")
                        ? h < 350 && null != c
                            ? e("[data-quickshop]").addClass("active_option_3")
                            : e("[data-quickshop]").removeClass("active_option_3")
                        : t.hasClass("product-card-layout-01")
                        ? h < 310 && null != c
                            ? e("[data-quickshop]").addClass("active_option_3")
                            : e("[data-quickshop]").removeClass("active_option_3")
                        : h < 370 && null != c
                        ? e("[data-quickshop]").addClass("active_option_3")
                        : e("[data-quickshop]").removeClass("active_option_3")
                    : t.hasClass("product-card-layout-01")
                    ? h < 310
                        ? null != d || null != c
                            ? e("[data-quickshop]").removeClass("active_option_3")
                            : e("[data-quickshop]").addClass("active_option_3")
                        : e("[data-quickshop]").removeClass("active_option_3")
                    : h < 370
                    ? null != d || null != c
                        ? e("[data-quickshop]").removeClass("active_option_3")
                        : e("[data-quickshop]").addClass("active_option_3")
                    : e("[data-quickshop]").removeClass("active_option_3");
            }
            if (
                (t.hasClass("quick_shop_option_2") && e(".productListing").hasClass("productList")
                    ? (d = a.find('[data-option-index="0"]').eq("1").find("input:checked").val())
                    : e(".productListing").hasClass("productList") && o.width() < 767
                    ? ((d = a.find('[data-option-index="0"]').eq("1").find("input:checked").val()), (c = a.find('[data-option-index="1"]').eq("1").find("input:checked").val()))
                    : (d = a.find('[data-option-index="0"]').eq("0").find("input:checked").val()),
                null != i && (n = i.variants),
                r.each((t, a) => {
                    var o = e(a).data("option-index"),
                        i = e(a).find(".swatch-element");
                    switch (o) {
                        case 0:
                            i.each((t, a) => {
                                var o = e(a),
                                    i = o.data("value"),
                                    s = n.find((e) => (1 == l ? e.option2 == i && e.available : 2 == l ? e.option3 == i && e.available : e.option1 == i && e.available)),
                                    r = n.find((e) => (1 == l ? e.option2 == i : 2 == l ? e.option3 == i : e.option1 == i));
                                null == s
                                    ? null == r
                                        ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1))
                                        : (o.removeClass("unavailable available").addClass("soldout").find(".single-action").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1))
                                    : (o.removeClass("soldout unavailable").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1));
                            });
                            break;
                        case 1:
                            i.each((t, a) => {
                                var o = e(a),
                                    i = o.data("value"),
                                    s = n.find((e) => (1 == l ? e.option2 == d && e.option1 == i && e.available : 2 == l ? e.option3 == d && e.option1 == i && e.available : e.option1 == d && e.option2 == i && e.available)),
                                    r = n.find((e) => (1 == l ? e.option2 == d && e.option1 == i : 2 == l ? e.option3 == d && e.option1 == i : e.option1 == d && e.option2 == i));
                                null == s
                                    ? null == r
                                        ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1))
                                        : (o.removeClass("unavailable available").addClass("soldout").find(".single-action-selector").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1))
                                    : (o.removeClass("soldout unavailable").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1));
                            });
                            break;
                        case 2:
                            i.each((t, a) => {
                                var o = e(a),
                                    i = o.data("value"),
                                    s = n.find((e) =>
                                        1 == l
                                            ? e.option2 == d && e.option1 == c && e.option3 == i && e.available
                                            : 2 == l
                                            ? e.option3 == d && e.option1 == c && e.option2 == i && e.available
                                            : e.option1 == d && e.option2 == c && e.option3 == i && e.available
                                    ),
                                    r = n.find((e) => (1 == l ? e.option2 == d && e.option1 == c && e.option3 == i : 2 == l ? e.option3 == d && e.option1 == c && e.option2 == i : e.option1 == d && e.option2 == c && e.option3 == i));
                                null == s
                                    ? null == r
                                        ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1))
                                        : (o.removeClass("unavailable available").addClass("soldout").find(".single-action-selector").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1))
                                    : (o.removeClass("unavailable soldout").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1));
                            });
                    }
                }),
                s.find(".selector-wrapper:not(.option-color)").each((t, a) => {
                    var o = e(a);
                    o.find(".swatch-element").find("input:checked").length < 1 &&
                        (o.find(".swatch-element.available").length > 0
                            ? o.find(".swatch-element.available").eq("0").find(".single-label").trigger("click")
                            : o.find(".swatch-element.soldout").eq("0").find(".single-label").trigger("click"));
                }),
                t.hasClass("quick_shop_option_2"))
            ) {
                var m = a.find("[data-quickshop]").eq(1).find('[name="id"]').val(),
                    w = window[`quick_view_inven_array_${u}`];
                if (null != w) {
                    var f = w[m],
                        v = parseInt(f),
                        g = a.find('input[name="quantity"]').eq(0);
                    g.attr("data-inventory-quantity", v), g.val() > v && (v > 0 ? g.val(v) : g.val(1));
                }
            }
        },
        initAddToCartQuickShop: function (e, t) {
            var a = t.find('[name="id"]').val();
            i.actionAddToCart(e, a, 1);
        },
        initAddToCart: function () {
            a.off("click.addToCart").on("click.addToCart", "[data-btn-addtocart]", (t) => {
                t.preventDefault(), t.stopPropagation();
                var o = e(t.target);
                o.parents(".product-item"), a.find("#halo-card-mobile-popup"), a.find(".quickshop-popup-show");
                if (o.closest("product-form").length > 0) {
                    var n = o.closest("form");
                    i.actionAddToCart2(o, n);
                } else if (o.hasClass("is-notify-me") || o.hasClass("is-soldout")) o.hasClass("is-notify-me") && i.notifyInStockPopup(o);
                else {
                    var s = o.parents("form"),
                        r = s.find('[name="id"]').val(),
                        l = s.find('[name="quantity"]').val();
                    (input = s.find('[name="quantity"]').eq(0)), null == l && (l = 1), i.actionAddToCart(o, r, l, input);
                }
            }),
                a.on("click", "[data-close-add-to-cart-popup]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("add-to-cart-show");
                }),
                a.on("click", (a) => {
                    t.hasClass("add-to-cart-show") && 0 === e(a.target).closest("[data-add-to-cart-popup]").length && t.removeClass("add-to-cart-show");
                });
        },
        actionAddToCart: function (o, n, s, r) {
            window.variantStrings.submit, window.variantStrings.addingToCart, window.variantStrings.addedToCart;
            o.hasClass("button-text-change") && o.text(),
                o.addClass("is-loading"),
                t.hasClass("quick-view-show")
                    ? Shopify.addItem(
                          n,
                          s,
                          () => {
                              "cart" == window.after_add_to_cart.type
                                  ? i.redirectTo(window.routes.cart)
                                  : Shopify.getCart((e) => {
                                        t.addClass("cart-sidebar-show"), i.updateSidebarCart(e), t.find("[data-cart-count]").text(e.item_count), o.removeClass("is-loading");
                                    });
                          },
                          r
                      )
                    : Shopify.addItem(
                          n,
                          s,
                          () => {
                              switch (
                                  (o.removeClass("is-loading"),
                                  t.hasClass("quickshop-popup-show") && t.hasClass("quick_shop_option_3") && (t.removeClass("quickshop-popup-show"), e(".quickshop-popup-show").removeClass("quickshop-popup-show")),
                                  t.hasClass("quickshop-list-view-show") && t.removeClass("quickshop-list-view-show"),
                                  t.hasClass("show-mobile-options") && (t.removeClass("show-mobile-options"), e(".background-overlay").addClass("hold")),
                                  t.hasClass("quick_shop_popup_mobile") &&
                                      t.hasClass("quick_shop_option_2") &&
                                      (t.removeClass("quick_shop_popup_mobile"),
                                      a.find("#halo-card-mobile-popup").removeClass("show"),
                                      a.find(".quickshop-popup-show").each((t, a) => {
                                          e(a).removeClass("quickshop-popup-show");
                                      })),
                                  window.after_add_to_cart.type)
                              ) {
                                  case "cart":
                                      i.redirectTo(window.routes.cart);
                                      break;
                                  case "quick_cart":
                                      window.quick_cart.show
                                          ? Shopify.getCart((a) => {
                                                "popup" == window.quick_cart.type || (t.addClass("cart-sidebar-show"), i.updateSidebarCart(a)), o.removeClass("is-loading"), e(".background-overlay").removeClass("hold");
                                            })
                                          : i.redirectTo(window.routes.cart);
                                      break;
                                  case "popup_cart_1":
                                      Shopify.getCart((a) => {
                                          i.updatePopupCart(a, 1), i.updateSidebarCart(a), t.addClass("add-to-cart-show"), o.removeClass("is-loading"), e(".background-overlay").removeClass("hold");
                                      });
                              }
                          },
                          r
                      );
        },
        actionAddToCart2: function (a, o) {
            fetchConfig("javascript");
            window.variantStrings.submit, window.variantStrings.addingToCart, window.variantStrings.addedToCart;
            a.hasClass("button-text-change") && a.text(), a.addClass("is-loading");
            let n = document.querySelector('[data-type="add-to-cart-form"]'),
                s = new FormData(n);
            document.querySelectorAll('input[name^="properties"]').forEach((e) => {
                null != e.value && ("file" == e.type ? s.append(e.name, e.files[0]) : s.append(e.name, e.value));
            });
            if (!i.checkSufficientStock(o) && t.hasClass("quickshop-popup-show")) return alert(window.cartStrings.addProductOutQuantity), void a.removeClass("is-loading");
            const r = () => {
                fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", body: s })
                    .then((e) => e.json())
                    .catch((e) => {
                        console.error("Error:", e);
                    })
                    .finally(() => {
                        if ((t.hasClass("quickshop-popup-show") && t.removeClass("quickshop-popup-show"), t.hasClass("quick-view-show")))
                            "cart" == window.after_add_to_cart.type
                                ? i.redirectTo(window.routes.cart)
                                : Shopify.getCart((e) => {
                                      t.find("[data-cart-count]").text(e.item_count), a.removeClass("is-loading");
                                  });
                        else
                            switch (window.after_add_to_cart.type) {
                                case "cart":
                                    i.redirectTo(window.routes.cart);
                                    break;
                                case "quick_cart":
                                    window.quick_cart.show
                                        ? Shopify.getCart((e) => {
                                              "popup" == window.quick_cart.type || (t.addClass("cart-sidebar-show"), i.updateSidebarCart(e)), a.removeClass("is-loading");
                                          })
                                        : i.redirectTo(window.routes.cart);
                                    break;
                                case "popup_cart_1":
                                    Shopify.getCart((e) => {
                                        i.updatePopupCart(e, 1), i.updateSidebarCart(e), t.addClass("add-to-cart-show"), a.removeClass("is-loading");
                                    });
                            }
                    });
            };
            fetch(window.Shopify.routes.root + "cart.js", { method: "GET" })
                .then((e) => e.json())
                .then((t) => {
                    const a = parseInt(e(n).serialize().split("id=")[1]),
                        i = t.items.find((e) => e.variant_id == a),
                        s = i?.quantity,
                        l = i?.product_id,
                        d = parseInt(o.find("[data-inventory-quantity]").val()),
                        c = parseInt(o.find("[data-inventory-quantity]").data("inventory-quantity")),
                        p = ("true" === document.getElementById("product-add-to-cart").dataset.available) | !1;
                    if (!s || !c || p) return r();
                    if ("deny" == window[`selling_array_${l}`][a]) {
                        if (s + d > c) {
                            const e = c - s;
                            throw new Error(`You ${e > 0 ? `can only add ${e}` : "cannot add"} more of the items into the cart`);
                        }
                        r();
                    } else r();
                })
                .catch((e) => {
                    this.showWarning(e);
                })
                .finally(() => {
                    a.removeClass("is-loading");
                });
        },
        checkSufficientStock: function (e) {
            return e.find("[data-inventory-quantity]").data("inventory-quantity") >= parseInt(e.find("[data-inventory-quantity]").val());
        },
        updateContentQuickshopOption3: function (a) {
            var o = e("#halo-quickshop-popup-option-3"),
                n = o.find(".halo-popup-content");
            e.ajax({
                type: "get",
                url: window.routes.root + "/products/" + a + "?view=ajax_quick_shop",
                beforeSend: function () {
                    e("[data-quick-view-popup] .halo-popup-content").empty();
                },
                success: function (e) {
                    n.html(e);
                },
                error: function (t, a) {
                    i.showWarning(e.parseJSON(t.responseText).description);
                },
                complete: function () {
                    var e = o.find(".quickshop");
                    i.productImageGallery(e),
                        setTimeout(() => {
                            t.addClass("quickshop-popup-show");
                        }, 150);
                },
            });
        },
        appendProductQuickShopOption2: function (o) {
            if (window.innerWidth <= 767) {
                var i = a.find("#halo-card-mobile-popup"),
                    n = o.clone();
                i.find(".halo-popup-content").empty(), n.find(".card-product__group").remove(), i.find(".halo-popup-content").append(n);
                var s = i.find("[data-quickshop] form").eq("0"),
                    r = s.attr("id") + "mobile";
                s.attr("id", r);
                var l = s.find(".single-option"),
                    d = s.find(".single-label");
                l.each((t, a) => {
                    e(a).attr("id", e(a).attr("id") + "-mobile");
                }),
                    d.each((t, a) => {
                        e(a).attr("for", e(a).attr("for") + "-mobile");
                    }),
                    i.addClass("show"),
                    a.on("click", (a) => {
                        e(a.target).hasClass("background-overlay") && (i.removeClass("show"), t.removeClass("quick_shop_popup_mobile"), o.removeClass("quickshop-popup-show"));
                    });
            }
        },
        isRunningInIframe: function () {
            try {
                return window.self !== window.top;
            } catch (e) {
                return !0;
            }
        },
        redirectTo: function (e) {
            i.isRunningInIframe() && !window.iframeSdk ? (window.top.location = e) : (window.location = e);
        },
        initQuickCart: function () {
            window.quick_cart.show && ("popup" == window.quick_cart.type || i.initSidebarCart()), i.initEventQuickCart();
        },
        initEventQuickCart: function () {
            i.removeItemQuickCart(), i.updateQuantityItemQuickCart(), i.editQuickCart();
        },
        productCollectionCartSlider: function () {
            e("[data-product-collection-cart]").each((t, a) => {
                var o = e(a).find(".products-carousel"),
                    i = o.data("item-dots"),
                    n = o.data("item-arrows");
                o.length > 0 &&
                    (o.hasClass("slick-initialized") ||
                        o.slick({
                            mobileFirst: !0,
                            adaptiveHeight: !1,
                            infinite: !1,
                            vertical: !1,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: !0,
                            arrows: !1,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [{ breakpoint: 1025, settings: { dots: i, arrows: n } }],
                        }));
            });
        },
        updatePopupCart: function (a, o) {
            var i = a.items[0],
                n = e("[data-add-to-cart-popup]").find(".product-added"),
                s = n.find(".product-title"),
                r = n.find(".product-image"),
                l = i.product_title,
                d = i.featured_image,
                c = '<img src="' + d.url + '" alt="' + d.alt + '" title="' + d.alt + '"/>';
            r.attr("href", i.url).html(c),
                s.find(".title").attr("href", i.url).empty().append(l),
                Shopify.getCart((e) => {
                    t.find("[data-cart-count]").text(e.item_count);
                });
        },
        initSidebarCart: function () {
            var o = e("[data-cart-sidebar]");
            Shopify.getCart((e) => {
                i.updateSidebarCart(e);
            }),
                t.hasClass("template-cart")
                    ? o.on("click", (t) => {
                          t.preventDefault(), t.stopPropagation(), e("html, body").animate({ scrollTop: 0 }, 700);
                      })
                    : o.on("click", (e) => {
                          e.preventDefault(), e.stopPropagation(), t.addClass("cart-sidebar-show");

                          // Baadmay code start
                          setTimeout(() => {
                            const cartSidebarElement = document.querySelector('baadmaypricerre');
                            if (cartSidebarElement) { 
                                const cartSidebarPrice = cartSidebarElement.getAttribute('total-cart-price');
                                if (cartSidebarPrice) { 
                                    var fee = sessionStorage.getItem("percentageAmount");
                                    if (fee) { 
                                        var sum = cartSidebarPrice * fee;
                                        var sum2 = Number(cartSidebarPrice) + Number(sum);
                                        var totalSum = Math.floor(sum2 / 3);
                                        cartSidebarElement.textContent = totalSum.toLocaleString();
                                    } else {
                                        console.warn("percentageAmount not found in sessionStorage");
                                    }
                                } else {
                                    console.warn("total-cart-price attribute not found");
                                }
                            }
                            var venobox = new VenoBox({
                              selector: '.baadmay-modal',
                              closeColor: '#000',
                              closeBackground: 'transparent',
                              overlayColor: 'rgba(0,0,0,.75)',
                              overlayClose: false,
                              customClass: 'baadmay-modal-container',
                            });
                          
                            document.addEventListener('click', function(event) {
                              if (event.target.classList.contains('baadmay-popup-close')) {
                                venobox.close();
                              }
                            });
                          }, 1000); 
                          // Baadmay code end
                      }),
                a.on("click", "[data-close-cart-sidebar]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.hasClass("cart-sidebar-show") && t.removeClass("cart-sidebar-show");
                }),
                t.on("click", ".background-overlay", (a) => {
                    !t.hasClass("cart-sidebar-show") ||
                        t.hasClass("edit-cart-show") ||
                        t.hasClass("term-condition-show") ||
                        t.hasClass("has-warning") ||
                        (0 === e(a.target).closest("#halo-cart-sidebar").length &&
                            0 === e(a.target).closest("[data-cart-sidebar]").length &&
                            0 === e(a.target).closest("[data-edit-cart-popup]").length &&
                            0 === e(a.target).closest("[data-warning-popup]").length &&
                            0 === e(a.target).closest("[data-term-condition-popup]").length &&
                            t.removeClass("cart-sidebar-show"));
                });
        },
        updateSidebarCart: function (a) {
            if (!e.isEmptyObject(a)) {
                const o = e("#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"),
                    n =
                        '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
                    s = "is-loading";
                o.addClass(s).prepend(n),
                    e.ajax({
                        type: "GET",
                        url: window.routes.root + "/cart?view=ajax_side_cart",
                        cache: !1,
                        success: function (t) {
                            var a = e(t);
                            o.removeClass(s).html(a), i.dispatchChangeForShippingMessage();

                            // Baadmay code start
                            setTimeout(() => {
                              const cartSidebarElement = document.querySelector('baadmaypricerre');
                              if (cartSidebarElement) { 
                                  const cartSidebarPrice = cartSidebarElement.getAttribute('total-cart-price');
                                  if (cartSidebarPrice) { 
                                      var fee = sessionStorage.getItem("percentageAmount");
                                      if (fee) { 
                                          var sum = cartSidebarPrice * fee;
                                          var sum2 = Number(cartSidebarPrice) + Number(sum);
                                          var totalSum = Math.floor(sum2 / 3);
                                          cartSidebarElement.textContent = totalSum.toLocaleString();
                                      } else {
                                          console.warn("percentageAmount not found in sessionStorage");
                                      }
                                  } else {
                                      console.warn("total-cart-price attribute not found");
                                  }
                              }
                              var venobox = new VenoBox({
                                selector: '.baadmay-modal',
                                closeColor: '#000',
                                closeBackground: 'transparent',
                                overlayColor: 'rgba(0,0,0,.75)',
                                overlayClose: false,
                                customClass: 'baadmay-modal-container',
                              });
                            
                              document.addEventListener('click', function(event) {
                                if (event.target.classList.contains('baadmay-popup-close')) {
                                  venobox.close();
                                }
                              });
                            }, 1000); 
                            // Baadmay code end
                        },
                        error: function (t, a) {
                            i.showWarning(e.parseJSON(t.responseText).description);
                        },
                        complete: function () {
                            t.find("[data-cart-count]").text(a.item_count),
                                i.productCollectionCartSlider(),
                                i.updateGiftWrapper(),
                                i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                                document.dispatchEvent(new CustomEvent("cart-update", { detail: a }));
                        },
                    });
            }
        },
        dispatchChangeForShippingMessage: function () {
            document.querySelectorAll("[data-free-shipping-wrapper]").forEach((e) => {
                const t = new Event("change", { bubbles: !0 });
                e.dispatchEvent(t);
            });
        },
        updateGiftWrapper: function () {
            let t;
            e("#gift-wrapping")
                .off("click")
                .on("click", (e) => {
                    e.stopPropagation(),
                        e.preventDefault(),
                        clearTimeout(t),
                        (t = setTimeout(() => {
                            const t = e.target.dataset.giftId;
                            Shopify.addItem(t, 1, () => {
                                Shopify.getCart((e) => {
                                    i.updateSidebarCart(e);
                                });
                            });
                        }, 250));
                }),
                e("#cart-gift-wrapping")
                    .off("click")
                    .on("click", (a) => {
                        a.stopPropagation(), a.preventDefault();
                        var o = e(a.currentTarget),
                            n = o.attr("data-adding-text");
                        o.text(n),
                            clearTimeout(t),
                            (t = setTimeout(() => {
                                const e = a.target.dataset.giftId;
                                Shopify.addItem(e, 1, () => {
                                    Shopify.getCart((e) => {
                                        i.updateCart(e);
                                    });
                                });
                            }, 250));
                    });
        },
        removeItemQuickCart: function () {
            a.on("click", "[data-cart-remove]", (a) => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget),
                    n = (o.attr("data-cart-remove-id"), e("#cart-gift-wrapping").attr("data-add-text")),
                    s = o.data("line");
                e("#cart-gift-wrapping").text(n),
                    Shopify.removeItem(s, (e) => {
                        t.hasClass("template-cart") ? i.updateCart(e) : t.hasClass("cart-modal-show") || (t.hasClass("cart-sidebar-show") && i.updateSidebarCart(e));
                    });
            });
        },
        updateCart: function (a) {
            if (!e.isEmptyObject(a)) {
                const o = e("#main-cart-items").data("id"),
                    n = e("[data-cart]"),
                    s = n.find("[data-cart-content]"),
                    r = n.find("[data-cart-total]"),
                    l =
                        '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
                    d = "is-loading";
                n.addClass(d).prepend(l),
                    e.ajax({
                        type: "GET",
                        url: `/cart?section_id=${o}`,
                        cache: !1,
                        success: function (t) {
                            // Baadmay code start
                            setTimeout(() => {
                              const cartTotal = $('.cart-total-subtotal .cart-total-value .text').text().replace(/Rs\./g, '').replace(/,/g, '').replace(/\./g, '').trim();
                              const hideWidget = Math.floor(cartTotal / 100);
                              
                              if(hideWidget >= 26000) {
                                $('.cartPage-widget').hide();
                              } else {
                                $('.cartPage-widget').show();
                              }

                              const CartPriceElement = document.querySelector('[total-cart-price]');
                              if (CartPriceElement) {
                                  var price = Math.floor(cartTotal / 100);
                                  CartPriceElement.setAttribute('total-cart-price', price);
                          
                                  var fee = sessionStorage.getItem("percentageAmount");
                          
                                  var sum = price * fee;
                                  var sum2 = Number(price) + Number(sum);
                                  var totalSum = Math.floor(sum2 / 3);
                          
                                  CartPriceElement.textContent = totalSum.toLocaleString();
                              }

                              var venobox = new VenoBox({
                                selector: '.baadmay-modal',
                                closeColor: '#000',
                                closeBackground: 'transparent',
                                overlayColor: 'rgba(0,0,0,.75)',
                                overlayClose: false,
                                customClass: 'baadmay-modal-container',
                              });
                            
                              document.addEventListener('click', function(event) {
                                if (event.target.classList.contains('baadmay-popup-close')) {
                                  venobox.close();
                                }
                              });
                            }, 500); 
                            // Baadmay code end
                            var o = t.replaceAll("cart-coupon-discount", "div"),
                                i = e(o);
                            if ((n.removeClass(d), n.find(".loading-overlay").remove(), a.item_count > 0)) {
                                var l = i.find("[data-cart-content] .cart").html(),
                                    c = i.find("[data-cart-total] .cart-total-subtotal").html(),
                                    p = i.find("[data-cart-total] .cart-total-grandtotal").html(),
                                    u = i.find("[data-cart-total] .cart-total-savings").html();
                                if ((s.find(".cart").html(l), r.find(".cart-total-subtotal").html(c), r.find(".cart-total-grandtotal").html(p), r.find(".cart-total-savings").html(u), i.find(".haloCalculatorShipping").length > 0)) {
                                    var h = i.find(".haloCalculatorShipping");
                                    n.find(".haloCalculatorShipping").replaceWith(h);
                                }
                            } else {
                                l = i.find("#main-cart-items").html();
                                var m = i.find(".page-header").html();
                                e("#main-cart-items").html(l), e(".page-header").html(m);
                            }
                        },
                        error: function (t, a) {
                            i.showWarning(e.parseJSON(t.responseText).description);
                        },
                        complete: function () {
                            if (
                                (t.find("[data-cart-count]").text(a.item_count),
                                i.dispatchChangeForShippingMessage(),
                                i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                                t.hasClass("template-cart"))
                            ) {
                                const t = document.getElementById("cart-gift-wrapping"),
                                    a = t?.dataset.isChecked,
                                    o = t?.dataset.giftId;
                                if ("true" === a) {
                                    e("#is-a-gift").hide();
                                    const a = document.querySelector(`[data-cart-remove-id="${o}"]`),
                                        i = document.querySelector(`[data-cart-quantity-id="${o}"]`);
                                    a?.addEventListener("click", () => {
                                        t.dataset.isChecked = "false";
                                    }),
                                        i?.addEventListener("change", (e) => {
                                            Number(e.target.value) <= 0 && (t.dataset.isChecked = "false");
                                        });
                                } else e("#is-a-gift").show();
                            }
                            document.dispatchEvent(new CustomEvent("cart-update", { detail: a }));
                        },
                    });
            }
        },
        updateQuantityItemQuickCart: function () {
            a.on("change", "[data-cart-quantity]", (a) => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget),
                    n = (o.attr("data-cart-quantity-id"), o.data("line")),
                    s = parseInt(o.val()),
                    r = parseInt(o.data("inventory-quantity"));
                let l = !0;
                if (r < s && r > 0) {
                    var d = `cart_selling_array_${a.currentTarget.closest("cart-update-quantity").dataset.product}`;
                    "deny" == window[d][a.currentTarget.closest("cart-update-quantity").dataset.variant] && ((s = r), (l = !1));
                }
                Shopify.changeItem(n, s, (e) => {
                    t.hasClass("template-cart") ? i.updateCart(e) : t.hasClass("cart-modal-show") || (t.hasClass("cart-sidebar-show") && i.updateSidebarCart(e)),
                        l || i.showWarning(`${window.cartStrings.addProductOutQuantity.replace("[maxQuantity]", s)}`);
                });
            });
        },
        editQuickCart: function () {
            a.on("click", "[data-open-edit-cart]", (a) => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget),
                    n = o.data("edit-cart-url"),
                    s = o.data("edit-cart-id"),
                    r = o.data("line"),
                    l = o.data("edit-cart-quantity");
                o.parents(".previewCartItem").find("previewCartItem-variant").text();
                const d = e("[data-edit-cart-popup]").find(".halo-popup-content");
                e.ajax({
                    type: "get",
                    url: n,
                    cache: !1,
                    dataType: "html",
                    beforeSend: function () {
                        t.hasClass("template-cart");
                    },
                    success: function (e) {
                        d.html(e), d.find("[data-template-cart-edit]").attr({ "data-cart-update-id": s, "data-line": r }), d.find(".product-edit-item").find('input[name="quantity"]').val(l);
                    },
                    error: function (a, o) {
                        i.showWarning(e.parseJSON(a.responseText).description), t.hasClass("template-cart");
                    },
                    complete: function () {
                        t.addClass("edit-cart-show"), t.hasClass("template-cart"), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format");
                    },
                });
            }),
                a.on("click", "[data-close-edit-cart]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("edit-cart-show");
                }),
                a.on("click", (a) => {
                    t.hasClass("edit-cart-show") && 0 === e(a.target).closest("[data-edit-cart-popup]").length && 0 === e(a.target).closest("[data-open-edit-cart]").length && t.removeClass("edit-cart-show");
                }),
                i.addMoreItemEditCart(),
                i.addAllItemCartEdit();
        },
        addMoreItemEditCart: function () {
            a.on("click", "[data-edit-cart-add-more]", (t) => {
                t.preventDefault(), t.stopPropagation();
                var a = e("[data-template-cart-edit]"),
                    o = e(t.target).parents(".product-edit-item"),
                    n = parseInt(a.attr("data-count")),
                    s = o.clone().removeClass("product-edit-itemFirst");
                (cloneProductId = s.attr("id") + n), s.attr("id", cloneProductId), i.updateClonedProductAttributes(s, n), s.insertAfter(o), (n += 1), a.attr("data-count", n);
            }),
                a.on("click", "[data-edit-cart-remove]", (t) => {
                    t.preventDefault(), t.stopPropagation(), e(t.target).parents(".product-edit-item").remove();
                });
        },
        updateClonedProductAttributes: function (t, a) {
            var o = e(".shopify-product-form", t),
                i = o.attr("id") + a;
            o.attr("id", i),
                e(".product-form__radio", t).each((t, o) => {
                    var i = e(o),
                        n = i.next(),
                        s = n.attr("for") + a,
                        r = i.attr("name");
                    n.attr("for", s), i.attr({ id: s, name: r + a });
                });
        },
        addAllItemCartEdit: function () {
            a.on("click", "#add-all-to-cart", (a) => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget),
                    n = e("[data-template-cart-edit]"),
                    s = n.find(".product-edit-item.isChecked");
                n.attr("data-cart-update-id");
                (productLine = n.data("line")),
                    s.length > 0
                        ? (o.addClass("is-loading"),
                          Shopify.removeItem(productLine, (a) => {
                              if (!e.isEmptyObject(a)) {
                                  var n = [];
                                  s.each((t, a) => {
                                      var o,
                                          i = e(a),
                                          s = i.find('input[name="id"]').val(),
                                          r = parseInt(i.find('input[name="quantity"]').val());
                                      n.push(((o = { type: "post", url: window.routes.root + "/cart/add.js", data: "quantity=" + r + "&id=" + s, dataType: "json", async: !1 }), e.ajax(o)));
                                  }),
                                      n.length > 0 &&
                                          e.when.apply(e, n).done((e) => {
                                              setTimeout(function () {
                                                  o.removeClass("is-loading");
                                              }, 1e3),
                                                  Shopify.getCart((e) => {
                                                      t.removeClass("edit-cart-show"), t.hasClass("template-cart") ? i.updateCart(e) : t.hasClass("cart-modal-show") || (t.hasClass("cart-sidebar-show") && i.updateSidebarCart(e));
                                                  });
                                          });
                              }
                          }))
                        : alert(window.variantStrings.addToCart_message);
            });
        },
        initNotifyInStock: function () {
            a.on("click", "[data-open-notify-popup]", (t) => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget);
                i.notifyInStockPopup(a);
            }),
                a.on("click", "[data-close-notify-popup]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("notify-me-show");
                }),
                a.on("click", (a) => {
                    t.hasClass("notify-me-show") && 0 === e(a.target).closest("[data-open-notify-popup]").length && 0 === e(a.target).closest("[data-notify-popup]").length && t.removeClass("notify-me-show");
                }),
                a.on("click", "[data-form-notify]", (t) => {
                    t.preventDefault(), t.stopPropagation();
                    var a = e(t.currentTarget);
                    i.notifyInStockAction(a);
                });
        },
        notifyInStockPopup: function (a) {
            var o,
                i = a.parents(".product-item"),
                n = i.find(".card-title").data("product-title"),
                s = i.find(".card-title").data("product-url"),
                r = e("[data-notify-popup]");
            (o = a.hasClass("is-notify-me") ? i.find(".card-swatch .swatch-label.is-active").attr("title") : a.data("variant-id")),
                r.find('[name="halo-notify-product-title"]').val(e.trim(n)),
                r.find('[name="halo-notify-product-link"]').val(s),
                o && r.find('[name="halo-notify-product-variant"]').val(o),
                t.addClass("notify-me-show");
        },
        notifyInStockAction: function (t) {
            var a,
                o = !0,
                n = t.parents(".halo-notifyMe"),
                s = n.find(".notifyMe-form"),
                r = n.find(".notifyMe-text"),
                l = n.find('input[name="email"]').val();
            if (
                (/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/.test(l) && l
                    ? (n.find(".form-field").removeClass("form-field--error").addClass("form-field--success"), r.html("").hide())
                    : (n.find(".form-field").removeClass("form-field--success").addClass("form-field--error"),
                      (o = !1),
                      (a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + window.notify_me.error + "</p></div>"),
                      r.html(a).show()),
                o)
            ) {
                var d = n.find('[name="halo-notify-product-site"]').val(),
                    c = n.find('[name="halo-notify-product-site-url"]').val(),
                    p = window.notify_me.mail,
                    u = window.notify_me.subject,
                    h = window.notify_me.label,
                    m = n.find('[name="halo-notify-product-title"]').val(),
                    w = n.find('[name="halo-notify-product-link"]').val(),
                    f = n.find('[name="halo-notify-product-variant"]').val(),
                    v =
                        '<div style="margin:30px auto;width:650px;border:10px solid #f7f7f7"><div style="border:1px solid #dedede">                        <h2 style="margin: 0; padding:20px 20px 20px;background:#f7f7f7;color:#555;font-size:2em;text-align:center;">' +
                        u +
                        "</h2>";
                (v +=
                    '<table style="margin:0px 0 0;padding:30px 30px 30px;line-height:1.7em">                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Product Name: </strong> ' +
                    m +
                    '</td></tr>                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Product URL: </strong> ' +
                    w +
                    '</td></tr>                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Email Request: </strong> ' +
                    l +
                    "</td></tr>                          " +
                    ("" != f ? '<tr><td style="padding: 5px 25px 5px 0;"><strong>Product Variant: </strong>' + f + "</td></tr>" : "") +
                    "                       </table>"),
                    (v += '<a href="' + c + '" style="display:block;padding:30px 0;background:#484848;color:#fff;text-decoration:none;text-align:center;text-transform:uppercase">&nbsp;' + d + "&nbsp;</a>");
                var g = { api: "i_send_mail", subject: u, email: p, from_name: h, email_from: l, message: (v += "</div></div>") };
                e.post(
                    "https://themevale.net/tools/sendmail/quotecart/sendmail.php",
                    g,
                    (e) => {
                        "error" == e.type
                            ? (a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + e.text + "</p></div>")
                            : ((a = '<div class="alertBox alertBox--success"><p class="alertBox-message">' + window.notify_me.success + "</p></div>"), i.resetForm(s)),
                            r.html(a).show();
                    },
                    "json"
                );
            }
        },
        initAskAnExpert: function () {
            a.on("click", "[data-open-ask-an-expert]", (a) => {
                a.preventDefault(), a.stopPropagation();
                var o,
                    i = e("[data-ask-an-expert-popup]").find(".halo-popup-content");
                if (t.hasClass("template-product")) {
                    var n = e(".productView").data("product-handle");
                    o = window.routes.root + "/products/" + n + "?view=ajax_ask_an_expert";
                } else if (t.hasClass("quick-view-show")) {
                    n = e(".halo-quickView").data("product-quickview-handle");
                    o = window.routes.root + "/products/" + n + "?view=ajax_ask_an_expert";
                } else o = window.routes.root + "/search?view=ajax_ask_an_expert";
                e.ajax({
                    type: "get",
                    url: o,
                    beforeSend: function () {
                        i.empty();
                    },
                    success: function (e) {
                        i.html(e);
                    },
                    error: function (t, a) {
                        alert(e.parseJSON(t.responseText).description);
                    },
                    complete: function () {
                        t.addClass("ask-an-expert-show");
                    },
                });
            }),
                a.on("click", "#halo-ask-an-expert-button", (t) => {
                    t.preventDefault(), t.stopPropagation();
                    var a = e(t.currentTarget);
                    i.askAnExpertAction(a);
                }),
                a.on("click", "[data-close-ask-an-expert]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("ask-an-expert-show");
                }),
                a.on("click", (a) => {
                    t.hasClass("ask-an-expert-show") && 0 === e(a.target).closest("[data-open-ask-an-expert]").length && 0 === e(a.target).closest("#halo-ask-an-expert-popup").length && t.removeClass("ask-an-expert-show");
                });
        },
        askAnExpertAction: function (t) {
            var a,
                o = !0,
                n = t.parents(".halo-ask-an-expert"),
                s = n.find(".halo-ask-an-expert-form"),
                r = n.find(".message"),
                l = n.find('input[name="askAnExpertMail"]').val(),
                d = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if (
                (e("input[required], textarea[required]", s).each((t, i) => {
                    e.trim(e(i).val())
                        ? (e(i).parent(".form-field").removeClass("form-field--error").addClass("form-field--success"), r.html("").hide())
                        : (e(i).parent(".form-field").removeClass("form-field--success").addClass("form-field--error"),
                          (a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + window.ask_an_expert.error_2 + "</p></div>"),
                          r.html(a).show(),
                          (o = !1)),
                        "askAnExpertMail" != e(i).attr("name") ||
                            d.test(l) ||
                            (e(i).parent(".form-field").removeClass("form-field--success").addClass("form-field--error"),
                            (a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + window.ask_an_expert.error_1 + "</p></div>"),
                            r.html(a).show(),
                            (o = !1));
                }),
                o)
            ) {
                var c = window.ask_an_expert.mail,
                    p = window.ask_an_expert.subject,
                    u = window.ask_an_expert.label,
                    h = n.find('[name="askAnExpertName"]').val(),
                    m = l,
                    w = n.find('[name="askAnExpertPhone"]').val(),
                    f = n.find("input[name=askAnExpertRadioFirst]:checked").val(),
                    v = n.find("input[name=askAnExpertRadioSecond]:checked").val(),
                    g = n.find('[name="askAnExpertMessag"]').val(),
                    C =
                        "<div style='border: 1px solid #e6e6e6;padding: 30px;max-width: 500px;margin: 0 auto;'>                                    <h2 style='margin-top:0;margin-bottom:30px;color: #000000;'>" +
                        p +
                        "</h2>                                    <p style='border-bottom: 1px solid #e6e6e6;padding-bottom: 23px;margin-bottom:25px;color: #000000;'>You received a new message from your online store's ask an expert form.</p>                                    <table style='width:100%;'>";
                if (n.hasClass("has-product")) {
                    var b = n.find('[name="halo-product-title"]').val(),
                        k = n.find('[name="halo-product-link"]').val();
                    C +=
                        "<tr>                                    <td style='border-bottom: 1px solid #e6e6e6;padding-bottom: 25px;margin-bottom:25px;width:50%;'>                                        <img style='width: 100px' src='https:" +
                        n.find('[name="halo-product-image"]').val().trim() +
                        "' alt='" +
                        b +
                        "' title='" +
                        b +
                        "'>                                    </td>                                    <td style='border-bottom: 1px solid #e6e6e6;padding-bottom: 25px;margin-bottom:25px;'>                                        <a href='" +
                        k +
                        "'>" +
                        b +
                        "</a>                                    </td>                                </tr>";
                }
                C +=
                    "<tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" +
                    window.ask_an_expert.customer_name +
                    ": </strong></td><td>" +
                    h +
                    "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" +
                    window.ask_an_expert.customer_mail +
                    ": </strong></td><td>" +
                    m +
                    "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" +
                    window.ask_an_expert.customer_phone +
                    ": </strong></td><td>" +
                    w +
                    "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" +
                    window.ask_an_expert.type_radio1 +
                    " </strong></td><td>" +
                    f +
                    "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" +
                    window.ask_an_expert.type_radio2 +
                    ": </strong></td><td>" +
                    v +
                    "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" +
                    window.ask_an_expert.customer_message +
                    "? </strong></td><td>" +
                    g +
                    "</td></tr>                        </table></div>";
                var y = { api: "i_send_mail", subject: p, email: c, from_name: u, email_from: l, message: C };
                e.post(
                    "https://themevale.net/tools/sendmail/quotecart/sendmail.php",
                    y,
                    (e) => {
                        "error" == e.type
                            ? (a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + e.text + "</p></div>")
                            : ((a = '<div class="alertBox alertBox--success"><p class="alertBox-message">' + window.ask_an_expert.success + "</p></div>"), i.resetForm(s), s.hide()),
                            r.html(a).show();
                    },
                    "json"
                );
            }
        },
        resetForm: function (t) {
            e(".form-field", t).removeClass("form-field--success form-field--error"), e("input[type=email], input[type=text], textarea", t).val("");
        },
        initCompareProduct: function () {
            var o = e("a[data-compare-link]");
            window.compare.show &&
                (i.setLocalStorageProductForCompare(o),
                i.setAddorRemoveProductForCompare(o),
                i.setProductForCompare(),
                a.on("click", "[data-close-compare-product-popup]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("compare-product-show");
                }),
                a.on("click", (a) => {
                    t.hasClass("compare-product-show") && 0 === e(a.target).closest("[data-compare-link]").length && 0 === e(a.target).closest("[data-compare-product-popup]").length && t.removeClass("compare-product-show");
                }));
        },
        setLocalStorageProductForCompare: function (t) {
            var a = JSON.parse(localStorage.getItem("compareItem")),
                o = e("[data-product-compare-handle]");
            null !== a &&
                o.length > 0 &&
                (o.each((t, o) => {
                    var i = e(o),
                        n = i.data("product-compare-handle");
                    a.indexOf(n) >= 0
                        ? (i.find(".compare-icon").addClass("is-checked"), i.find(".text").text(window.compare.added), i.find("input").prop("checked", !0))
                        : (i.find(".compare-icon").removeClass("is-checked"), i.find(".text").text(window.compare.add), i.find("input").prop("checked", !1));
                }),
                i.updateCounterCompare(t));
        },
        setAddorRemoveProductForCompare: function (t) {
            a.on("change", "[data-product-compare] input", (a) => {
                var o = e(a.currentTarget),
                    n = o.parents(".card-compare"),
                    s = o.val(),
                    r = JSON.parse(localStorage.getItem("compareItem"));
                (r = i.uniqueArray(r)),
                    a.currentTarget.checked
                        ? (n.find(".compare-icon").addClass("is-checked"), n.find(".text").text(window.compare.added), n.find("input").prop("checked", !0), i.incrementCounterCompare(r, s, t))
                        : (n.find(".compare-icon").removeClass("is-checked"), n.find(".text").text(window.compare.add), n.find("input").prop("checked", !1), i.decrementCounterCompare(r, s, t));
            });
        },
        setProductForCompare: function () {
            a.on("click", "[data-compare-link]", (e) => {
                e.preventDefault(), e.stopPropagation();
                var t = JSON.parse(localStorage.getItem("compareItem"));
                if (t.length <= 1) return alert(window.compare.message), !1;
                i.updateContentCompareProduct(t);
            }),
                a.on("click", "[data-compare-remove]", (a) => {
                    a.preventDefault(), a.stopPropagation();
                    var o = e(a.currentTarget).data("compare-item"),
                        n = e("[data-compare-product-popup] .compareTable"),
                        s = n.find('.compareTable-row[data-product-compare-id="' + o + '"]'),
                        r = s.data("compare-product-handle");
                    if (1 == n.find("tbody .compareTable-row").length) {
                        s.remove();
                        var l = (c = JSON.parse(localStorage.getItem("compareItem"))).indexOf(r),
                            d = e("a[data-compare-link]");
                        l > -1 && (c.splice(l, 1), (c = i.uniqueArray(c)), localStorage.setItem("compareItem", JSON.stringify(c)), i.setLocalStorageProductForCompare(d), i.updateCounterCompare(d)), t.removeClass("compare-product-show");
                    } else {
                        s.remove();
                        var c;
                        (l = (c = JSON.parse(localStorage.getItem("compareItem"))).indexOf(r)), (d = e("a[data-compare-link]"));
                        l > -1 && (c.splice(l, 1), (c = i.uniqueArray(c)), localStorage.setItem("compareItem", JSON.stringify(c)), i.setLocalStorageProductForCompare(d), i.updateCounterCompare(d));
                    }
                });
        },
        updateCounterCompare: function (e) {
            var t = JSON.parse(localStorage.getItem("compareItem"));
            t.length > 1 ? (e.parent().addClass("is-show"), e.find("span.countPill").html(t.length)) : e.parent().removeClass("is-show");
        },
        uniqueArray: function (t) {
            var a = [];
            return (
                e.each(t, function (t, o) {
                    -1 == e.inArray(o, a) && a.push(o);
                }),
                a
            );
        },
        incrementCounterCompare: function (e, t, a) {
            e.indexOf(t);
            e.push(t), (e = i.uniqueArray(e)), localStorage.setItem("compareItem", JSON.stringify(e)), i.updateCounterCompare(a);
        },
        decrementCounterCompare: function (e, t, a) {
            const o = e.indexOf(t);
            o > -1 && (e.splice(o, 1), (e = i.uniqueArray(e)), localStorage.setItem("compareItem", JSON.stringify(e)), i.updateCounterCompare(a));
        },
        updateContentCompareProduct: function (a) {
            var o = e("[data-compare-product-popup]").find(".compareTable");
            o.find("tbody").empty(),
                e.ajax({
                    type: "get",
                    url: window.routes.root + "/collections/all",
                    cache: !1,
                    data: { view: "ajax_product_card_compare", constraint: `limit=${a.length}+sectionId=list-compare+list_handle=` + encodeURIComponent(a) },
                    beforeSend: function () {},
                    success: function (e) {
                        o.find("tbody").append(e);
                    },
                    error: function (t, a) {
                        alert(e.parseJSON(t.responseText).description);
                    },
                    complete: function () {
                        t.addClass("compare-product-show");
                    },
                });
        },
        initProductView: function (e) {
            i.productImageGallery(e),
                i.productLastSoldOut(e),
                i.productCustomerViewing(e),
                i.productCountdown(e),
                i.productSizeChart(e),
                i.productCustomCursor(e),
                i.productVideoGallery(e),
                i.initVariantImageGroup(e, window.variant_image_group);
        },
        initQuickView: function () {
            a.on("click", "[data-open-quick-view-popup]", (t) => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget).data("product-handle");
                i.updateContentQuickView(a);

                // Baadmay Code Start
                setTimeout(() => {
                  const quickviewPriceElement = document.querySelector('.quickview-widget .price-divide');
                  const quickviewPriceDivide = quickviewPriceElement.getAttribute('total-prod-price');
                  const quickviewPrice = quickviewPriceDivide / 100;
                  
                  if (quickviewPrice) {
                      var fee = sessionStorage.getItem("percentageAmount");
                    
                      var sum = quickviewPrice * fee;
                      var sum2 = Number(quickviewPrice) + Number(sum);
                      var totalSum = Math.floor(sum2 / 3);

                      console.log('totalSum', totalSum);
                    
                      quickviewPriceElement.textContent = totalSum.toLocaleString();
                  }
                  var venobox = new VenoBox({
                    selector: '.baadmay-modal',
                    closeColor: '#000',
                    closeBackground: 'transparent',
                    overlayColor: 'rgba(0,0,0,.75)',
                    overlayClose: false,
                    customClass: 'baadmay-modal-container',
                  });
                
                  document.addEventListener('click', function(event) {
                    if (event.target.classList.contains('baadmay-popup-close')) {
                      venobox.close();
                    }
                  });
                }, 1000); 
                // Baadmay Code End
            }),
                a.on("click", "[data-close-quick-view-popup]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("quick-view-show");
                }),
                e(".background-overlay")
                    .off("click.closeQuickView")
                    .on("click.closeQuickView", (e) => {
                        !t.hasClass("quick-view-show") ||
                            t.hasClass("cart-sidebar-show") ||
                            t.hasClass("ask-an-expert-show") ||
                            t.hasClass("size-chart-show") ||
                            t.hasClass("compare-color-show") ||
                            t.hasClass("term-condition-show") ||
                            t.removeClass("quick-view-show");
                    });
        },
        updateContentQuickView: function (a) {
            var o = e("[data-quick-view-popup]"),
                n = o.find(".halo-popup-content");
            e.ajax({
                type: "get",
                url: window.routes.root + "/products/" + a + "?view=ajax_quick_view",
                beforeSend: function () {
                    n.empty(), e("#halo-quickshop-popup-option-3").find(".halo-popup-content").empty();
                },
                success: function (e) {
                    n.html(e);
                },
                error: function (t, a) {
                    alert(e.parseJSON(t.responseText).description);
                },
                complete: function () {
                    var n = o.find(".quickView");
                    const s = e(".halo-popup-content .halo-compare-color-popup li.item"),
                        r = e(".halo-popup-content .halo-compare-color-popup #sortTableList"),
                        l = e(".halo-popup-content .halo-compare-color-popup"),
                        d = e(".halo-popup-content .halo-size-chart-popup");
                    if (
                        (i.productImageGallery(n),
                        i.productLastSoldOut(n),
                        i.productCustomerViewing(n),
                        i.productCountdown(n),
                        i.productSizeChart(n),
                        i.setProductForWishlist(a),
                        i.initVariantImageGroup(n, window.variant_image_group_quick_view),
                        t.addClass("quick-view-show"),
                        window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                        r.attr("id", "quickViewSortTableList"),
                        s.each((t, a) => {
                            const o = e(a).find(".swatch-compare-color-option"),
                                i = e(a).find(".swatch-compare-color-label"),
                                n = o.attr("id");
                            o.attr("id", `quickView-${n}`).attr("name", `quickView-${n}`), i.attr("for", `quickView-${n}`);
                        }),
                        l.attr("id", "quickView-halo-compare-color-popup"),
                        d.attr("id", "quickView-halo-size-chart-popup"),
                        e(".halo-productView .addthis_inline_share_toolbox").length)
                    ) {
                        var c = e(".halo-productView .addthis_inline_share_toolbox").html();
                        e(".halo-popup-content .share-button__button").click(function () {
                            e(".halo-popup-content .addthis_inline_share_toolbox").append(c);
                        });
                    }
                    const p = document.getElementById("quickViewSortTableList"),
                        u = e(".halo-popup-content .halo-compareColors-image");
                    if (
                        (window.innerWidth >= 1025 && p
                            ? new Sortable(p, { animation: 150 })
                            : u.on("click", ".item", (t) => {
                                  t.preventDefault();
                                  var a = `swatch-compare-color-${t.currentTarget.classList[1].replace("item-", "")}`;
                                  e(document.getElementById(a)).trigger("click");
                              }),
                        window.review.show_quick_view && e(".shopify-product-reviews-badge").length > 0 && null != window.SPR && "functions" == typeof window.SPR.registerCallbacks)
                    )
                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                },
            });
        },
        productImageGallery: function (a) {
            var n = a.find(".productView-nav"),
                s = a.find('.productView-for:not(".mobile")'),
                r = a.find(".productView-for.mobile");
            if (!s.hasClass("slick-initialized") && !n.hasClass("slick-initialized")) {
                const t = n.data("arrows-desk"),
                    f = n.data("arrows-mobi"),
                    v = n.data("counter-mobi"),
                    g = n.data("media-count"),
                    C = parseInt(s.data("max-thumbnail-to-show"));
                let b, k, y;
                var l;
                (y = n.hasClass("productView-nav-gallery") ? Math.round(g / 2) : g), (y = n.hasClass("productView-horizontal-tabs") && 2 == g ? 1 : g);
                const _ =
                    '<div class="slick-counter">\n                    <span class="slick-counter--current">1</span>\n                    <span aria-hidden="true">/</span>\n                    <span class="slick-counter--total">' +
                    y +
                    "</span>\n                </div>";
                if (
                    (n.on("init", () => {
                        window.innerWidth < 768 &&
                            v &&
                            "false" == variant_image_group &&
                            (clearTimeout(l),
                            (l = setTimeout(() => {
                                n.append(_);
                            }, 1e3)),
                            n.on("reInit afterChange", function (e, t, a, o) {
                                var i = (a || 0) + 1;
                                n.find(".slick-counter--current").text(i);
                            }));
                    }),
                    n.on("reInit", () => {
                        clearTimeout(l),
                            (l = setTimeout(() => {
                                n.append(_);
                            }, 1e3));
                    }),
                    (k = !n.closest(".productView").is(".layout-4") && s),
                    n.hasClass("productView-nav-gallery"))
                ) {
                    var d = (u = a.find(".productView-nav.productView-nav-gallery")).data("media-count"),
                        c = 2,
                        p = 2;
                    1 == d && ((c = 1), (p = 1)),
                        2 == d && ((c = 2), (p = 1)),
                        u.slick({
                            dots: !0,
                            rows: p,
                            arrows: t,
                            infinite: !0,
                            slidesPerRow: 1,
                            slidesToShow: c,
                            focusOnSelect: !1,
                            asNavFor: k,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [{ breakpoint: 767, settings: { arrows: f } }],
                        });
                } else if (n.hasClass("productView-horizontal-tabs")) {
                    var u;
                    (c = 2), (p = 1);
                    (u = a.find(".productView-nav.productView-horizontal-tabs")).slick({
                        dots: !0,
                        rows: p,
                        arrows: t,
                        infinite: !0,
                        slidesPerRow: 1,
                        slidesToShow: c,
                        focusOnSelect: !1,
                        asNavFor: k,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [{ breakpoint: 767, settings: { arrows: f } }],
                    });
                } else
                    !n.is(".style-2, .style-3") || window.innerWidth < 768
                        ? (n.slick({
                              fade: !0,
                              dots: !1,
                              arrows: t,
                              infinite: !0,
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              asNavFor: k,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              rtl: window.rtl_slick,
                              responsive: [{ breakpoint: 768, settings: { arrows: f } }],
                          }),
                          (b = n))
                        : (b = !1);
                if (
                    (a.hasClass("layout-1") || a.hasClass("layout-2")
                        ? (s.on("init", (e, t) => {
                              s.find(".animated-loading").removeClass("animated-loading");
                          }),
                          s.slick({
                              slidesToShow: C,
                              slidesToScroll: 1,
                              asNavFor: b,
                              arrows: !0,
                              dots: !1,
                              draggable: !1,
                              adaptiveHeight: !1,
                              focusOnSelect: !0,
                              vertical: !0,
                              verticalSwiping: !0,
                              infinite: !0,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              responsive: [
                                  { breakpoint: 1600, settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 } },
                                  { breakpoint: 1280, settings: { vertical: !1, verticalSwiping: !1, rtl: window.rtl_slick } },
                                  { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1, vertical: !1, verticalSwiping: !1, rtl: window.rtl_slick } },
                              ],
                          }))
                        : a.hasClass("layout-3") &&
                          (s.on("init", (e, t) => {
                              s.find(".animated-loading").removeClass("animated-loading");
                          }),
                          s.slick({
                              slidesToShow: C,
                              slidesToScroll: 1,
                              asNavFor: b,
                              arrows: !0,
                              dots: !1,
                              focusOnSelect: !0,
                              infinite: !0,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              rtl: window.rtl_slick,
                              responsive: [
                                  { breakpoint: 1600, settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 } },
                                  { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                              ],
                          })),
                    r.on("init", (e, t) => {
                        r.find(".animated-loading").removeClass("animated-loading");
                    }),
                    r.slick({
                        slidesToShow: parseInt(r.data("max-thumbnail-to-show")),
                        slidesToScroll: 1,
                        asNavFor: b,
                        arrows: !0,
                        dots: !1,
                        draggable: !1,
                        adaptiveHeight: !1,
                        focusOnSelect: !0,
                        vertical: !0,
                        verticalSwiping: !0,
                        infinite: !0,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            { breakpoint: 1600, settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 } },
                            { breakpoint: 1280, settings: { vertical: !1, verticalSwiping: !1 } },
                            { breakpoint: 767, settings: { slidesToShow: 2.2, slidesToScroll: 1, vertical: !1, verticalSwiping: !1 } },
                        ],
                    }),
                    a.hasClass("layout-1") || a.hasClass("layout-2"))
                ) {
                    var h = s.outerHeight(),
                        m = (n.outerHeight() - h) / 2,
                        w = m + 80;
                    o.width() > 1279
                        ? s.find(".slick-arrow").length > 0
                            ? (s.parent().addClass("arrows-visible"), s.parent().css("top", m))
                            : (s.parent().addClass("arrows-disable"), s.parent().css("top", w))
                        : s.find(".slick-arrow").length > 0
                        ? s.parent().css("top", "unset")
                        : s.parent().css("top", w);
                }
                if (n.find("[data-youtube]").length > 0)
                    if (void 0 === window.onYouTubeIframeAPIReady) {
                        window.onYouTubeIframeAPIReady = i.initYoutubeCarousel.bind(window, n);
                        const e = document.createElement("script");
                        e.src = "https://www.youtube.com/player_api";
                        const t = document.getElementsByTagName("script")[0];
                        t.parentNode.insertBefore(e, t);
                    } else i.initYoutubeCarousel(n);
                n.find("[data-vimeo]").length > 0 &&
                    (n.on("beforeChange", (t, a) => {
                        var o, i;
                        (i = { method: "pause", value: "true" }), null != (o = e(a.$slider).find(".slick-current").find("iframe").get(0)) && o.contentWindow.postMessage(JSON.stringify(i), "*");
                    }),
                    n.on("afterChange", (t, a) => {
                        var o, i;
                        (i = { method: "play", value: "true" }), null != (o = e(a.$slider).find(".slick-current").find("iframe").get(0)) && o.contentWindow.postMessage(JSON.stringify(i), "*");
                    })),
                    n.find("[data-mp4]").length > 0 &&
                        (n.on("beforeChange", (t, a) => {
                            var o;
                            null != (o = e(a.$slider).find(".slick-current").find("video").get(0)) && o.pause();
                        }),
                        n.on("afterChange", (t, a) => {
                            var o;
                            null != (o = e(a.$slider).find(".slick-current").find("video").get(0)) && o.play();
                        }));
            }
            var f = a.find("[data-fancybox]");
            if ((f.length > 0 && f.fancybox({ buttons: ["zoom", "share", "slideShow", "fullScreen", "thumbs", "close"], loop: !0, thumbs: { autoStart: !0 } }), t.hasClass("template-product"))) {
                if (a.closest(".quickView").length) return;
                var v = a.find("[data-zoom-image]");
                o.width() > 1024 &&
                    v.each((t, a) => {
                        var i = e(a);
                        o.width() > 1024 ? i.zoom({ url: i.attr("data-zoom-image"), touch: !1 }) : i.trigger("zoom.destroy");
                    });
            }
            o.on("resize", () => {
                (a.hasClass("layout-1") || a.hasClass("layout-2")) &&
                    (o.width() > 1279
                        ? setTimeout(() => {
                              if (s.find(".slick-arrow").length > 0) {
                                  var e = s.outerHeight(),
                                      t = (n.outerHeight() - e) / 2;
                                  s.parent().addClass("arrows-visible"), s.parent().css("top", t);
                              } else s.parent().addClass("arrows-disable");
                          }, 200)
                        : setTimeout(() => {
                              s.find(".slick-arrow").length > 0 && s.parent().css("top", "unset");
                          }, 200));
            });
        },
        productVideoGallery: function (a) {
            const i = a.find("[data-video-thumbnail]").length,
                n = e(".productView-video").length;
            if (i) {
                const i = a.find(".productView-image-wrapper"),
                    s = e("[data-popup-video]"),
                    r = a.find(".productView-nav");
                let l = i.offset().top + i.outerHeight();
                n && t.addClass("has-product-video"),
                    o.on("scroll", (o) => {
                        const i = e(o.currentTarget),
                            n = a.find(".slick-current .productView-video"),
                            d = n.data("type"),
                            c = n.data("video-url");
                        if (null != c)
                            if (i.scrollTop() > l) {
                                if (!s.is(".is-show")) {
                                    const e = r.find(".slick-slide.slick-active").data("youtube-player"),
                                        a = parseInt(e.getCurrentTime()),
                                        o = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">\n                                                    ${
                                            "youtube" == d
                                                ? `<iframe\n                                                            id="player"\n                                                            type="text/html"\n                                                            width="100%"\n                                                            frameborder="0"\n                                                            webkitAllowFullScreen\n                                                            mozallowfullscreen\n                                                            allowFullScreen\n                                                            src="https://www.youtube.com/embed/${c}?autoplay=1&mute=1&start=${a}">\n                                                        </iframe>`
                                                : `<iframe \n                                                            src="https://player.vimeo.com/video/${c}?autoplay=1&mute=1" \n                                                            class="js-vimeo" \n                                                            allow="autoplay; \n                                                            encrypted-media" \n                                                            webkitallowfullscreen \n                                                            mozallowfullscreen \n                                                            allowfullscreen">\n                                                        </iframe>`
                                        }\n                                                </div>`;
                                    s.addClass("is-show"), s.find(".halo-popup-content").html(o), t.addClass("video-show product-video-show"), e.pauseVideo();
                                }
                            } else {
                                const e = r.find(".slick-slide.slick-active").data("youtube-player");
                                s.removeClass("is-show"), s.find(".halo-popup-content").empty(), t.removeClass("video-show product-video-show"), e.playVideo();
                            }
                    });
            }
        },
        initVariantImageGroup: function (t, o = !1) {
            if (o) {
                var i = t.find("[data-filter]:checked"),
                    n = t.find(".productView-for"),
                    s = t.find(".productView-nav");
                if (i.length > 0) {
                    var r = i.data("filter");
                    void 0 !== r && (s.slick("slickUnfilter"), n.slick("slickUnfilter"), s.find(r).length && n.find(r).length && (s.slick("slickFilter", r).slick("refresh"), n.slick("slickFilter", r).slick("refresh")));
                }
                a.on("change", "input[data-filter]", (t) => {
                    var a = e(t.currentTarget).data("filter");
                    s.slick("slickUnfilter"), n.slick("slickUnfilter"), void 0 !== a && s.find(a).length && n.find(a).length && (s.slick("slickFilter", a).slick("refresh"), n.slick("slickFilter", a).slick("refresh"));
                });
            }
        },
        initYoutubeCarousel: function (t) {
            t.each((t, a) => {
                const o = e(a);
                o.find("[data-youtube]").length > 0 && (o.addClass("slick-slider--video"), i.initYoutubeCarouselEvent(a));
            });
        },
        initYoutubeCarouselEvent: function (t) {
            var o = e(t),
                i = o.find("[data-youtube]");
            function n(t) {
                e(t.target.getIframe()).closest(".slick-slide").data("youtube-player", t.target),
                    setTimeout(function () {
                        e(t.target.getIframe()).closest(".slick-slide").hasClass("slick-active") && (o.slick("slickPause"), t.target.playVideo());
                    }, 200);
            }
            function s(e) {
                e.data === YT.PlayerState.PLAYING && o.slick("slickPause"), e.data === YT.PlayerState.ENDED && o.slick("slickNext");
            }
            function r() {
                i.each((t, a) => {
                    const o = e(a),
                        i = `youtube_player_${Math.floor(100 * Math.random())}`;
                    o.attr("id", i);
                    new YT.Player(i, {
                        host: "http://www.youtube.com",
                        videoId: o.data("youtube"),
                        wmode: "transparent",
                        playerVars: { autoplay: 0, controls: 0, disablekb: 1, enablejsapi: 1, fs: 0, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, wmode: "transparent" },
                        events: { onReady: n, onStateChange: s },
                    });
                });
            }
            function l() {
                const e = o.find(".slick-slide.slick-active").data("youtube-player");
                e && (e.stopVideo(), o.removeClass("slick-slider--playvideo"));
            }
            function d() {
                const e = o.find(".slick-slide.slick-active").data("youtube-player");
                e && (o.slick("slickPause"), o.addClass("slick-slider--playvideo"), e.playVideo());
            }
            !(function () {
                o.hasClass("slick-initialized") && r();
                a.on("init", o, r), a.on("beforeChange", o, l), a.on("afterChange", o, d);
            })();
        },
        productSizeChart: function (o) {
            window.sizeChart = function () {
                o.find("[data-open-size-chart-popup]").on("click", (t) => {
                    t.preventDefault(),
                        t.stopPropagation(),
                        document.body.classList.add("size-chart-show"),
                        document.body.classList.contains("quick-view-show") ? e(".halo-popup-content .halo-size-chart-popup").addClass("is-show") : e("#MainContent .halo-size-chart-popup").addClass("is-show");
                }),
                    a.on("click", "[data-close-size-chart-popup]", () => {
                        t.removeClass("size-chart-show"), e(".halo-size-chart-popup").removeClass("is-show");
                    }),
                    a.on("click", (a) => {
                        t.hasClass("size-chart-show") && 0 === e(a.target).closest("[data-open-size-chart-popup]").length && 0 === e(a.target).closest("[data-size-chart-popup]").length && t.removeClass("size-chart-show");
                    });
            };
            var i = document.body.classList.contains("quick-view-show"),
                n = e(".halo-productView .productView-sizeChart").length;
            document.body.classList.contains("template-product") ? ((!i && n) || (i && 0 === n)) && window.sizeChart() : window.sizeChart();
        },
        productLastSoldOut: function (e) {
            var t = e.find("[data-sold-out-product]");
            if (t.length > 0) {
                var a = t.data("item").toString().split(","),
                    o = Math.floor(Math.random() * a.length),
                    i = t.data("hours").toString().split(","),
                    n = Math.floor(Math.random() * i.length);
                t.find("[data-sold-out-number]").text(a[o]), t.find("[data-sold-out-hours]").text(i[n]), t.show();
            }
        },
        productCustomerViewing: function (e) {
            var t = e.find("[data-customer-view]");
            if (t.length > 0) {
                var a = t.data("customer-view"),
                    o = JSON.parse("[" + a + "]"),
                    i = t.data("customer-view-time"),
                    n = 1e3 * parseInt(i);
                setInterval(function () {
                    var e = Math.floor(Math.random() * o.length);
                    t.find(".text").text(window.customer_view.text.replace("[number]", o[e]));
                }, n);
            }
        },
        productCountdown: function (e) {
            var t = e.find("[data-countdown-id]"),
                a = t.data("countdown"),
                o = new Date(a).getTime(),
                i = window.countdown.text;
            if (t.length > 0)
                var n = setInterval(function () {
                    var e = new Date().getTime(),
                        a = o - e;
                    if (a < 0) clearInterval(n), t.remove();
                    else {
                        var s,
                            r = Math.floor(a / 864e5),
                            l = Math.floor((a % 864e5) / 36e5),
                            d = Math.floor((a % 36e5) / 6e4),
                            c = Math.floor((a % 6e4) / 1e3);
                        (s = t.is(".style-2, .style-3")
                            ? '<span class="text"><span>' +
                              i +
                              '</span></span><span class="num">' +
                              r +
                              "<span>" +
                              window.countdown.day_2 +
                              '</span></span>                                <span class="num">' +
                              l +
                              "<span>" +
                              window.countdown.hour_2 +
                              '</span></span>                                <span class="num">' +
                              d +
                              "<span>" +
                              window.countdown.min_2 +
                              '</span></span>                                <span class="num">' +
                              c +
                              "<span>" +
                              window.countdown.sec_2 +
                              "</span></span>"
                            : '<span class="text"><span>' +
                              i +
                              '</span></span><span class="num">' +
                              r +
                              "<span>" +
                              window.countdown.day +
                              '</span></span>                                <span class="num">' +
                              l +
                              "<span>" +
                              window.countdown.hour +
                              '</span></span>                                <span class="num">' +
                              d +
                              "<span>" +
                              window.countdown.min +
                              '</span></span>                                <span class="num">' +
                              c +
                              "<span>" +
                              window.countdown.sec +
                              "</span></span>"),
                            t.html(s),
                            t.addClass("show");
                    }
                }, 1e3);
        },
        productCustomCursor: function (t) {
            if (0 == e(".cursor-wrapper").length) return;
            const { Back: a } = window;
            (this.cursorWrapper = document.querySelector(".cursor-wrapper")),
                (this.innerCursor = document.querySelector(".custom-cursor__inner")),
                (this.outerCursor = document.querySelector(".custom-cursor__outer")),
                (this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect()),
                (this.innerCursorBox = this.innerCursor.getBoundingClientRect()),
                (this.outerCursorBox = this.outerCursor.getBoundingClientRect()),
                document.addEventListener("mousemove", (e) => {
                    (this.clientX = e.clientX), (this.clientY = e.clientY);
                });
            const o = () => {
                TweenMax.set(this.cursorWrapper, { x: this.clientX, y: this.clientY }), requestAnimationFrame(o);
            };
            requestAnimationFrame(o), (this.fullCursorSize = 60), (this.enlargeCursorTween = TweenMax.to(this.outerCursor, 0.3, { width: this.fullCursorSize, height: this.fullCursorSize, ease: this.easing, paused: !0 }));
            const i = () => {
                    this.enlargeCursorTween.play(), e(".cursor-wrapper").addClass("handleMouseEnter").removeClass("handleMouseLeave");
                },
                n = () => {
                    this.enlargeCursorTween.reverse(), e(".cursor-wrapper").addClass("handleMouseLeave").removeClass("handleMouseEnter");
                };
            document.querySelectorAll(".productView-image").forEach((e) => {
                e?.querySelector(".productView-video") || (e.addEventListener("mouseenter", i), e.addEventListener("mouseleave", n));
            }),
                (this.bumpCursorTween = TweenMax.to(this.outerCursor, 0.1, {
                    scale: 0.7,
                    paused: !0,
                    onComplete: () => {
                        TweenMax.to(this.outerCursor, 0.2, { scale: 1, ease: this.easing });
                    },
                })),
                e(document).on("mouseover", "[data-cursor-image]", (t) => {
                    var a = e(t.currentTarget),
                        o = new Array();
                    o.push(a.attr("data-index")), e("#count-image").text(o[0]);
                }),
                (e.fn.isInViewport = function (t) {
                    var a = e(this).offset().top,
                        o = a + e(this).height(),
                        i = e(document).scrollTop(),
                        n = i + e(window).height();
                    if (t) {
                        var s = (o - i) / e(this).height();
                        return o > i && a < n && s > 0.5;
                    }
                    return o > i && a < n;
                }),
                (e(".product-full-width").length > 0 || e(".product-full-width-2").length > 0) &&
                    e(window).on("resize scroll", function () {
                        var t = new Array();
                        e(".productView-image").each(function () {
                            e(this).isInViewport(!0) && (t.push(e(this).attr("data-index")), e("#count-image").text(t[0]));
                        });
                    });
        },
        initWishlist: function () {
            window.wishlist.show &&
                (i.setLocalStorageProductForWishlist(),
                a.on("click", "[data-wishlist]", (t) => {
                    t.preventDefault(), t.stopPropagation(), e(t.currentTarget).hasClass("is-in-grid") || e("[data-wishlist-items-display]").removeClass("is-loaded");
                    var a = e(t.currentTarget),
                        o = a.data("product-id"),
                        n = a.data("wishlist-handle"),
                        s = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
                    if (((index = s.indexOf(n)), (wishlistContainer = e("[data-wishlist-container]")), (wishlistLayout = wishlistContainer.attr("data-wishlist-layout")), a.hasClass("wishlist-added"))) {
                        if ((a.removeClass("wishlist-added").find(".text").text(window.wishlist.add), wishlistContainer.length > 0 && e('[data-wishlist-added="wishlist-' + o + '"]').length > 0)) {
                            e('[data-wishlist-added="wishlist-' + o + '"]').remove();
                            e(`[data-wishlist][data-product-id=${o}]`).closest(".product").remove();
                        }
                        s.splice(index, 1), localStorage.setItem("wishlistItem", JSON.stringify(s));
                        const t = new CustomEvent("updatepagination", { bubbles: !0 });
                        if ((document.dispatchEvent(t), wishlistContainer.length > 0))
                            if ((s = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : []).length > 0) {
                                const e = new Event("updatewishlistmail", { bubbles: !0 });
                                document.dispatchEvent(e);
                            } else
                                e("[data-wishlist-container]")
                                    .addClass("is-empty")
                                    .html(
                                        `                                    <div class="wishlist-content-empty text-center">                                        <span class="wishlist-content-text">${window.wishlist.empty}</span>                                        <div class="wishlist-content-actions">                                            <a class="button button-2 button-continue" href="${window.routes.collection_all}">                                                ${window.wishlist.continue_shopping}                                            </a>                                        </div>                                    </div>                                `
                                    ),
                                    e("[data-wishlist-footer]").hide();
                    } else {
                        if ((a.addClass("wishlist-added").find(".text").text(window.wishlist.added), wishlistContainer.length > 0)) {
                            const e = new CustomEvent("addwishlistitem", { detail: { handle: n }, bubbles: !0 });
                            document.dispatchEvent(e);
                        }
                        s.push(n), localStorage.setItem("wishlistItem", JSON.stringify(s));
                        const e = new CustomEvent("updatewishlistmail", { bubbles: !0 });
                        document.dispatchEvent(e);
                    }
                    e("[data-wishlist-count]").text(s.length), i.setProductForWishlist(n);
                }));
        },
        calculateCard06Padding() {
            if (!t.hasClass("product-card-layout-06")) return;
            const e = document.querySelector(".card .card-action.card-grid__hidden");
            e.classList.remove("card-grid__hidden");
            const a = e.scrollHeight;
            document.querySelector("[data-wishlist-items-grid-display]").style.setProperty("--card-06-padding", a + "px"), e.classList.add("card-grid__hidden");
        },
        setProductForWishlist: function (t) {
            var a = JSON.parse(localStorage.getItem("wishlistItem")),
                o = e('[data-wishlist-handle="' + t + '"]'),
                i = a?.indexOf(t);
            null != i && null != a && (i >= 0 ? o.addClass("wishlist-added").find(".text").text(window.wishlist.added) : o.removeClass("wishlist-added").find(".text").text(window.wishlist.add));
        },
        setLocalStorageProductForWishlist: function () {
            var t = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
            localStorage.setItem("wishlistItem", JSON.stringify(t)),
                t.length > 0 &&
                    (t = JSON.parse(localStorage.getItem("wishlistItem"))).forEach((e) => {
                        i.setProductForWishlist(e);
                    }),
                e("[data-wishlist-count]").text(t.length);
        },
        initCountdown: function () {
            var t = e("[data-countdown-announcement]"),
                a = e("[data-countdown]").not("[data-countdown-id]");
            t.length &&
                t.each(function () {
                    var t = e(this),
                        a = t.data("countdown-value"),
                        o = new Date(a).getTime(),
                        i = setInterval(function () {
                            var e = new Date().getTime(),
                                a = o - e;
                            if (a < 0)
                                if ((clearInterval(i), t.hasClass("hide--countdown"))) t.remove();
                                else {
                                    const e = t.parents(".announcement-bar__message"),
                                        a = t.parents("[data-announcement-bar]");
                                    a.is(".slick-initialized") ? a.slick("slickRemove", e.data("slick-index")) : e.remove();
                                }
                            else {
                                var n,
                                    s = Math.floor(a / 864e5),
                                    r = `0${Math.floor((a % 864e5) / 36e5)}`.slice(-2),
                                    l = `0${Math.floor((a % 36e5) / 6e4)}`.slice(-2),
                                    d = `0${Math.floor((a % 6e4) / 1e3)}`.slice(-2);
                                (n =
                                    '<div class="clock-item"><span class="num">' +
                                    s +
                                    '</span><span class="text">' +
                                    window.countdown.days +
                                    '</span></div>                                            <div class="clock-item"><span class="num">' +
                                    r +
                                    '</span><span class="text">' +
                                    window.countdown.hours +
                                    '</span></div>                                            <div class="clock-item"><span class="num">' +
                                    l +
                                    '</span><span class="text">' +
                                    window.countdown.mins +
                                    '</span></div>                                            <div class="clock-item"><span class="num">' +
                                    d +
                                    '</span><span class="text">' +
                                    window.countdown.secs +
                                    "</span></div>"),
                                    t.html(n);
                            }
                        }, 1e3);
                }),
                a.length &&
                    a.each(function () {
                        var t = e(this),
                            a = t.data("countdown-value"),
                            o = new Date(a).getTime(),
                            i = setInterval(function () {
                                var a = new Date().getTime(),
                                    n = o - a;
                                if (n < 0) clearInterval(i), t.hasClass("hide--countdown") ? t.remove() : t.parents(".shopify-section").remove();
                                else {
                                    var s = Math.floor(n / 864e5),
                                        r = `0${Math.floor((n % 864e5) / 36e5)}`.slice(-2),
                                        l = `0${Math.floor((n % 36e5) / 6e4)}`.slice(-2),
                                        d = `0${Math.floor((n % 6e4) / 1e3)}`.slice(-2),
                                        c = "";
                                    (c = t.hasClass("product-countdown-block")
                                        ? e(".halo-block-header").hasClass("countdown_style_2")
                                            ? '<div class="clock-item"><span class="num">' +
                                              s +
                                              window.countdown.d +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              r +
                                              window.countdown.h +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              l +
                                              window.countdown.m +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              d +
                                              window.countdown.s +
                                              '</span><span class="icon"></span></div>'
                                            : `<div class="clock-item"><span class="num">${s}d&nbsp;</span></div>\n                                    <div class="clock-item"><span class="num">${r}:</span></div>\n                                    <div class="clock-item"><span class="num">${l}:</span></div>\n                                    <div class="clock-item"><span class="num">${d}</span></div>`
                                        : '<div class="clock-item"><span class="num">' +
                                          s +
                                          '</span><span class="text">' +
                                          window.countdown.days +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          r +
                                          '</span><span class="text">' +
                                          window.countdown.hours +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          l +
                                          '</span><span class="text">' +
                                          window.countdown.mins +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          d +
                                          '</span><span class="text">' +
                                          window.countdown.secs +
                                          "</span></div>"),
                                        t.html(c);
                                }
                            }, 1e3);
                    });
        },
        collectionCountdown: function () {
            var t = e("[data-collection-countdown]");
            t.length &&
                t.each(function () {
                    var t = e(this),
                        a = (e) => {
                            var t = e.data("collection-countdown-value"),
                                o = new Date(t).getTime(),
                                i = (window.countdown.text, o - new Date().getTime());
                            if (i < 0) clearInterval(a), e.hasClass("hide--countdown") && e.remove();
                            else {
                                var n = Math.floor(i / 864e5),
                                    s = `0${Math.floor((i % 864e5) / 36e5)}`.slice(-2),
                                    r = `0${Math.floor((i % 36e5) / 6e4)}`.slice(-2),
                                    l = `0${Math.floor((i % 6e4) / 1e3)}`.slice(-2),
                                    d = "";
                                e.hasClass("collection-countdown") &&
                                    (d =
                                        '<div class="clock-item"><span class="num">' +
                                        n +
                                        '</span><span class="text">' +
                                        window.countdown.days +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        s +
                                        '</span><span class="text">' +
                                        window.countdown.hours +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        r +
                                        '</span><span class="text">' +
                                        window.countdown.mins +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        l +
                                        '</span><span class="text">' +
                                        window.countdown.secs +
                                        "</span></div>"),
                                    e.html(d);
                            }
                        };
                    setInterval(() => {
                        a(t);
                    }, 1e3);
                });
        },
        handleScrollDown: function () {
            var t = "[data-scroll-down]",
                a = e(t);
            a.each(function () {
                var t = e(this),
                    o = t.closest(".shopify-section").next(".shopify-section").attr("id");
                t.attr("href", "#" + o),
                    a.on("click", function (t) {
                        t.preventDefault();
                        var a = e(this.getAttribute("href"));
                        a.length && e("html, body").stop().animate({ scrollTop: a.offset().top }, 400);
                    });
            });
        },
        toggleSidebarMobile: function () {
            a.on("click", "[data-sidebar]", (e) => {
                e.preventDefault(), e.stopPropagation(), t.addClass("open-mobile-sidebar");
            }),
                a.on("click", "[data-close-sidebar]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t.removeClass("open-mobile-sidebar");
                }),
                a.on("click", (a) => {
                    t.hasClass("open-mobile-sidebar") && 0 === e(a.target).closest("[data-sidebar]").length && 0 === e(a.target).closest("#halo-sidebar").length && t.removeClass("open-mobile-sidebar");
                });
        },
        initBlogMasonry: function () {
            const a = e(".blog-layout-masonry .blog-block-item"),
                o = t.hasClass("layout_rtl");
            a.masonry({ columnWidth: ".blog-grid-sizer", itemSelector: "[data-masonry-item]", isRTL: o, originLeft: !o });
        },
        articleGallery: function () {
            const t = e(".articleGallery-block"),
                a = e(".articleGallery-slider"),
                o = t.length,
                i = a.data("col");
            o > 0 &&
                a.not(".slick-initialized") &&
                a.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    arrows: !0,
                    infinite: !1,
                    mobileFirst: !0,
                    focusOnSelect: !1,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 767, settings: { slidesToShow: i, slidesToScroll: i } },
                        { breakpoint: 319, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    ],
                });
        },
        initCollapseSidebarBlock: function () {
            a.on("click", ".sidebarBlock-headingWrapper .sidebarBlock-heading", (t) => {
                var a = e(t.currentTarget),
                    o = a.parent().siblings(),
                    i = a.parents(".sidebarBlock");
                a.hasClass("is-clicked") ? (a.removeClass("is-clicked"), o.slideUp("slow")) : (a.addClass("is-clicked"), o.slideDown("slow"), i.hasClass("sidebar-product") && i.find(".products-carousel").slick("refresh"));
            });
        },
        initCategoryActive: function () {
            e(".all-categories-list").length > 0 &&
                (a.on("click", ".all-categories-list .icon-dropdown", (t) => {
                    var a = e(t.currentTarget).parent();
                    a.siblings().removeClass("is-clicked current-cate"), a.toggleClass("is-clicked"), a.siblings().find("> .dropdown-category-list").slideUp("slow"), a.find("> .dropdown-category-list").slideToggle("slow");
                }),
                e(".all-categories-list li").each((t, a) => {
                    e(a).hasClass("current-cate") && e(a).find("> .dropdown-category-list").slideToggle("slow");
                }));
        },
        productBlockSilderSidebar: function () {
            var t = e("[data-product-slider-sidebar]"),
                a = t.data("item-to-show"),
                o = t.data("item-dots"),
                i = t.data("item-arrows");
            t.length > 0 &&
                t.not(".slick-initialized") &&
                t.slick({
                    mobileFirst: !0,
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: a,
                    slidesToScroll: 1,
                    arrows: i,
                    dots: o,
                    autoplay: !0,
                    autoplaySpeed: 2e3,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                });
        },
        productBlockSilderArticle: function () {
            var t = e("[data-product-slider-article]"),
                a = t.data("item-to-show"),
                o = t.data("item-dots"),
                i = t.data("item-arrows");
            t.length > 0 &&
                t.not(".slick-initialized") &&
                t.slick({
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: a,
                    slidesToScroll: 1,
                    arrows: i,
                    dots: o,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                        { breakpoint: 551, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    ],
                });
        },
        articleGallery: function () {
            const t = e(".articleGallery-block"),
                a = e(".articleGallery-slider"),
                o = t.length,
                i = a.data("col");
            o > 0 &&
                a.not(".slick-initialized") &&
                a.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    arrows: !0,
                    infinite: !1,
                    mobileFirst: !0,
                    focusOnSelect: !1,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 767, settings: { slidesToShow: i, slidesToScroll: i } },
                        { breakpoint: 319, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    ],
                });
        },
        initInfiniteScrolling: function () {
            e(!0) &&
                o.on("scroll load", () => {
                    var t = o.scrollTop(),
                        a = e(".pagination-infinite"),
                        n = a.find("[data-infinite-scrolling]");
                    if (n.length > 0 && !n.hasClass("is-loading") && t > a.offset().top - 500) {
                        var s = n.attr("href");
                        i.doAjaxInfiniteScrollingGetContent(s, n);
                    }
                }),
                a.on("click", "[data-infinite-scrolling]", (t) => {
                    var a = e(t.currentTarget),
                        o = a.attr("href");
                    t.preventDefault(), t.stopPropagation(), i.doAjaxInfiniteScrollingGetContent(o, a);
                });
        },
        doAjaxInfiniteScrollingGetContent: function (t, a) {
            e.ajax({
                type: "GET",
                url: t,
                beforeSend: function () {
                    a.text(a.attr("data-loading-more")), a.addClass("is-loading");
                },
                success: function (e) {
                    i.ajaxInfiniteScrollingMapData(e);
                },
                error: function (t, a) {
                    alert(e.parseJSON(t.responseText).description);
                },
                complete: function () {
                    a.text(a.attr("data-load-more")), a.removeClass("is-loading"), document.querySelector(".collection-masonry") && resizeAllGridItems();
                },
            });
        },
        ajaxInfiniteScrollingMapData: function (t) {
            var a = e("#CollectionProductGrid"),
                o = a.find(".productListing"),
                n = a.find(".pagination"),
                s = e(t).find("#CollectionProductGrid"),
                r = s.find(".productListing"),
                l = s.find(".pagination"),
                d = r.children(".product");
            if (d.length > 0) {
                if ((o.append(d), n.replaceWith(l), e("[data-total-start]").text(1), window.compare.show)) {
                    var c = e("a[data-compare-link]");
                    i.setLocalStorageProductForCompare(c);
                }
                window.wishlist.show && i.setLocalStorageProductForWishlist(), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format");
            }
        },
        initQuickShopProductList: function () {
            a.on("click", "[data-open-quickshop-popup-list]", (t) => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget).data("product-handle"),
                    o = e(t.currentTarget).closest(".card");
                o.hasClass("quick-shop-show") || i.updateContentQuickShop(o, a);
            }),
                a.on("click", "[data-close-quickshop-popup-list]", (t) => {
                    t.preventDefault(), t.stopPropagation();
                    var a = e(t.currentTarget).closest(".card");
                    a.removeClass("quick-shop-show"), a.find(".card-popup-content").empty();
                }),
                a.on("click", (t) => {
                    e(".card").hasClass("quick-shop-show") &&
                        0 === e(t.target).closest("[data-open-quickshop-popup-list]").length &&
                        0 === e(t.target).closest(".card-popup").length &&
                        (e(".card").removeClass("quick-shop-show"), e(".card").find(".card-popup-content").empty());
                });
        },
        updateContentQuickShop: function (t, a) {
            var o = t.find(".card-popup").find(".card-popup-content");
            e.ajax({
                type: "get",
                url: window.routes.root + "/products/" + a + "?view=ajax_quick_shop",
                beforeSend: function () {
                    e(".card").removeClass("quick-shop-show");
                },
                success: function (e) {
                    o.append(e);
                },
                error: function (t, a) {
                    alert(e.parseJSON(t.responseText).description);
                },
                complete: function () {
                    t.addClass("quick-shop-show");
                },
            });
        },
        toggleVariantsForExpressOrder: function () {
            e(document).on("click", "[data-toggle-variant]", function (t) {
                t.preventDefault(), t.stopPropagation();
                var a = e(this),
                    o = a.data("target");
                a.hasClass("show-options-btn")
                    ? (a.text(window.inventory_text.hide_options),
                      e(o).slideDown(700, function () {
                          a.addClass("hide-options-btn").removeClass("show-options-btn");
                      }))
                    : (a.text(window.inventory_text.show_options),
                      e(o).slideUp(700, function () {
                          a.addClass("show-options-btn").removeClass("hide-options-btn");
                      }));
            });
        },
        initExpressOrderAddToCart: function () {
            var t = "[data-express-addtocart]";
            e(document)
                .off("click.addToCartExpress", t)
                .on("click.addToCartExpress", t, function (t) {
                    t.preventDefault();
                    var a = e(this);
                    if ("disabled" != a.attr("disabled")) {
                        var o = a.closest(".product-item");
                        0 == o.length && (o = a.closest(".col-options"));
                        var n = o.find("form"),
                            s = n.find("select[name=id]").val();
                        s || (s = n.find("input[name=id]").val());
                        var r = o.find("input[name=quantity]");
                        0 == r.length && (r = o.siblings(".col-qtt").find("input[name=quantity]"));
                        var l = r.val();
                        l || (l = 1), 0 !== parseInt(l) ? ("none" == window.ajax_cart ? n.submit() : (i.expressAjaxAddToCart(s, l, a, n), n.next(".feedback-text").show())) : n.next(".feedback-text").text("Quantity cannot be blank").show();
                    }
                    return !1;
                });
        },
        expressAjaxAddToCart: function (a, o, n, s) {
            e.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + o + "&id=" + a,
                dataType: "json",
                beforeSend: function () {
                    window.setTimeout(function () {
                        n.text(window.inventory_text.adding + "...");
                    }, 100);
                },
                success: function (e) {
                    switch (
                        (window.setTimeout(function () {
                            n.text(window.inventory_text.thank_you), n.addClass("add_more"), s.next(".feedback-text").text(window.inventory_text.cart_feedback).addClass("is-added");
                        }, 600),
                        window.setTimeout(function () {
                            n.text(window.inventory_text.add_more + "...");
                        }, 1e3),
                        window.after_add_to_cart.type)
                    ) {
                        case "cart":
                            i.redirectTo(window.routes.cart);
                            break;
                        case "quick_cart":
                            window.quick_cart.show
                                ? Shopify.getCart((e) => {
                                      "popup" == window.quick_cart.type || (t.addClass("cart-sidebar-show"), i.updateSidebarCart(e));
                                  })
                                : i.redirectTo(window.routes.cart);
                            break;
                        case "popup_cart_1":
                            Shopify.getCart((e) => {
                                i.updatePopupCart(e, 1), i.updateSidebarCart(e), t.addClass("add-to-cart-show");
                            });
                    }
                },
                error: function (t, a) {
                    alert(e.parseJSON(t.responseText).description),
                        window.setTimeout(function () {
                            n.text(window.inventory_text.add_to_cart);
                        }, 400);
                },
            });
        },
        initProductBundle: function () {
            var t = e("[data-product-bundle]"),
                a = t.find("[data-bundle-slider]"),
                o = a.data("dots"),
                i = a.data("arrows");
            a.length > 0 &&
                (a.hasClass("slick-initialized") ||
                    (a.slick({
                        dots: !0,
                        arrows: i,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        mobileFirst: !0,
                        infinite: !1,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1, dots: o } },
                            { breakpoint: 551, settings: { slidesToShow: 3, slidesToScroll: 1, dots: o } },
                        ],
                    }),
                    t.find(".bundle-product-wrapper").removeClass("has-halo-block-loader"),
                    a.on("afterChange", function () {
                        a.find(".bundle-product-item").removeClass("is-open");
                    })));
        },
        initProductReviewSection: function () {
            a.ready(() => {
                setTimeout(() => {
                    const t = e(".productView-review .spr-content"),
                        a = e(".shopify-app-block .spr-content");
                    if (t && a) {
                        const e = t.html();
                        a.html(e);
                    }
                }, 1e3);
            });
        },
        initDynamicBrowserTabTitle: function () {
            if (window.dynamic_browser_title.show) {
                var e = document.title;
                window.dynamic_browser_title.text;
                (window.onblur = function () {
                    document.title = window.dynamic_browser_title.text;
                }),
                    (window.onfocus = function () {
                        document.title = e;
                    });
            }
        },
        initWarningPopup: function () {
            (this.warningPopup = document.querySelector("[data-warning-popup]")),
                (this.warningPopupContent = this.warningPopup.querySelector("[data-halo-warning-content]")),
                (this.warningPopupCloseButton = this.warningPopup.querySelector("[data-close-warning-popup]")),
                this.warningPopupCloseButton.addEventListener("click", () => {
                    document.body.classList.remove("has-warning");
                }),
                (this.warningTime = 3e3),
                (this.warningTimeout = void 0),
                (window.warningTimeout = this.warningTimeout);
        },
        showWarning: function (e, t = this.warningTime) {
            this.warningTimeout && clearTimeout(this.warningTimeout),
                (this.warningPopupContent.textContent = e),
                document.body.classList.add("has-warning"),
                t &&
                    (this.warningTimeout = setTimeout(() => {
                        document.body.classList.remove("has-warning");
                    }, t));
        },
        backgroundOverlayHoverEffect: function () {
            const e = document.querySelector(".background-overlay"),
                t = document.querySelector(".background-cursor-wrapper"),
                a = () => {
                    t.classList.remove("enlarge-cursor");
                },
                o = (e, a) => {
                    requestAnimationFrame(() => {
                        t.style.setProperty("--translate-y", a), t.style.setProperty("--translate-x", e);
                    });
                },
                i = (e) => {
                    o(e.clientX, e.clientY);
                };
            e.addEventListener("mouseenter", (e) => {
                o(e.clientX, e.clientY), t.classList.add("enlarge-cursor");
            }),
                e.addEventListener("mouseleave", (e) => {
                    o(e.clientX, e.clientY), t.removeEventListener("mousemove", i), a();
                }),
                e.addEventListener("mousemove", i),
                e.addEventListener("click", a);
        },
        productBlockScroller: function (e) {
            const { Back: t } = window,
                a = t.easeInOut.config(1.7);
            let o = e.get(0)?.querySelector(".products-cursor");
            if (!o) return;
            o.querySelector(".products-cursor__inner");
            let i,
                n,
                s = o.querySelector(".products-cursor__image"),
                r = o.querySelector(".products-cursor__icon"),
                l = e.get(0)?.querySelectorAll(".halo-block-content.is-scroll, .products-load.is-scroll"),
                d = e.get(0)?.querySelectorAll(".card-product__group, .card-action, .card-title, .card-swatch, .variants-popup, .card-compare, .card-quickview, .card-wishlist, .list-product-tabs");
            document.addEventListener("mousemove", (e) => {
                (i = e.clientX), (n = e.clientY), (docClientX = e.clientX), (docClientY = e.clientY);
            });
            const c = () => {
                TweenMax.set(o, { x: i, y: n }), requestAnimationFrame(c);
            };
            requestAnimationFrame(c);
            const p = TweenMax.to([o], 0.1, { scale: 2.5, opacity: 1, backgroundColor: "rgba(42,104,118,1)", ease: a, paused: !0 }),
                u = TweenMax.to([s, r], 0.1, { opacity: 1, ease: a, paused: !0 }),
                h = (e) => {
                    p.play(), u.play(), o.classList.add("handleMouseEnter"), o.classList.remove("handleMouseLeave");
                },
                m = (e) => {
                    p.reverse(), u.reverse(), o.classList.add("handleMouseLeave"), o.classList.remove("handleMouseEnter");
                };
            l.forEach((e) => {
                e.addEventListener("mouseenter", h), e.addEventListener("mouseleave", m);
            }),
                d.forEach((e) => {
                    e.addEventListener("mouseenter", m), e.addEventListener("mouseleave", h);
                });
        },
        productCustomInformation() {
            const o = e("[data-custom-information]"),
                i = e("#halo-product-custom-information");
            o.on("click", (a) => {
                const o = e(a.currentTarget),
                    n = o.find(".title")[0].innerText,
                    s = o.find(".product-customInformation__popup").html();
                "" !== s && null != s && (i.addClass("is-show"), i.find(".halo-popup-title").text(n), i.find(".halo-popup-content").html(s), t.addClass("is-custom-information"));
            }),
                a.on("click", "[data-close-custom-information]", () => {
                    t.removeClass("is-custom-information"), i.removeClass("is-show");
                }),
                a.on("click", (a) => {
                    t.hasClass("is-custom-information") && 0 === e(a.target).closest("#halo-product-custom-information").length && 0 === e(a.target).closest("[data-custom-information]").length && t.removeClass("is-custom-information");
                });
        },
        initLazyloadObserver(e, t) {
            const a = (e) => {
                e.closest(".card").classList.add("ajax-loaded");
            };
            this.lazyloadedObserver = new MutationObserver((e, t) => {
                e.forEach((e) => {
                    if ("attributes" == e.type) {
                        if (!e.target.classList.contains("lazyloaded")) return;
                        a(e.target);
                    }
                });
            });
            const o = new MutationObserver((e) => {
                e.forEach((e) => {
                    if ("childList" == e.type) {
                        [...e.addedNodes]
                            .map((e) => e.querySelector(".media--loading-effect img"))
                            .forEach((e) => {
                                this.lazyloadedObserver.observe(e, { childList: !0, attributes: !0 });
                            });
                    }
                });
            });
            t && o.observe(t, { subtree: !1, childList: !0 }),
                e.length > 0 &&
                    e.forEach((e) => {
                        e.classList.contains("lazyloaded") ? a(e) : this.lazyloadedObserver.observe(e, { childList: !0, attributes: !0 });
                    });
        },
        observeImageLazyloaded(e) {
            e.forEach((e) => {
                this.lazyloadedObserver.observe(e, { childList: !0, attributes: !0 });
            });
        },
        iconZoomClickMobile() {
            e(".productView-iconZoom").on("click", (e) => {
                document.querySelector(".productView-image .productView-img-container .media").click();
            });
        },
        calculateTranslateYHeight() {
            const e = document.querySelectorAll(".card .card-action:not(.variants-popup-form)");
            let t = 0;
            e.length &&
                (e.forEach((e) => {
                    e.classList.add("temporary-show");
                    const a = e.clientHeight;
                    a > t && (t = a), e.classList.remove("temporary-show");
                }),
                document.body.style.setProperty("--translate-y-height", -1 * t + "px"));
        },
        checkScrollLayoutForRecenlyViewed() {
            const t = document.getElementById("recently-viewed-products-list-2");
            if (t && t.classList.contains("products-flex")) {
                new MutationObserver((a, o) => {
                    const n = a[0];
                    if ("attributes" == n.type && n.target.classList.contains("recently-viewed-loaded")) {
                        "true" === e(n.target.closest("[data-recently-viewed-block]")).find("[data-enable-hover]").attr("data-enable-hover") &&
                            t.clientWidth < t.scrollWidth &&
                            i.productBlockScroller(e(n.target.closest("[data-recently-viewed-block]"))),
                            o.disconnect();
                    }
                }).observe(t, { attributes: !0 });
            }
        },
    };
})(jQuery);
document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.fabric-2')) { // Check if 'class1' exists
        var elements = document.querySelectorAll('.new-badge');
        elements.forEach(function(el) {
            el.style.position = 'absolute';  // Change or add CSS to 'class2'
            el.style.left = '0';
        });
    }
});

